/* eslint-disable quotes */
/* eslint-disable max-len */
import { EventEmitter, Injectable } from '@angular/core';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { DispatchBoardService } from '../../components/dispatch-board/dispatch-board.service';
import _ from 'lodash';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { BadgeOptions, badgeColorCode } from 'app/components/badge/badge.interface';
import { TitleCasePipe } from '@angular/common';
import { DateTimePipe } from 'app/core/pipes/datetimeformator.pipe';
import { DateFormatPipe } from 'app/core/pipes/dateFormat.pipe';
import dayjs from 'dayjs';
import { TimeFormatPipe } from 'app/core/pipes/timeFormat.pipe';
import moment from 'moment';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import RRule from 'rrule';
import { RecurringRouteService } from 'app/components/recurring-route-details/recurring-route.service';
import { JobColorType, TemplateType } from '../../components/dispatch-board/dispatch-board.interface';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  gridData: any;
  metaData: any;
  singletonRows = ['work_order_scheduled_date@Scheduled-Date-&-Time', 'employee_name@Technician-Name'];
  userPreferences: any = this._localStorageService.getLocalStorage('user_preferences');
  userRole: string;
  objectKeys = Object.keys;
  timeSheetValue: { punchedIn: string; punchedOut: string };
  capacityHours: { hours: number; minutes: number } = null;
  fieldsVisibility: any = null;
  dateRange: { fromDate: string; toDate: string } = null;
  userDetails: any = null;
  preferences: any = null;
  viewMode: string = null;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  modeOfTransportIcon = { 'CAR': 'ti-car', 'TRUCK': 'ti-truck', 'BIKE': 'ti-bike', 'WALK': 'ti ti-walk', 'PEDESTRIAN': 'ti ti-walk' };
  previewEmitter: EventEmitter<any> = new EventEmitter();

  constructor(
    private _dispatchBoardService: DispatchBoardService,
    private _localStorageService: LocalStorageService,
    private _dataCollectorService: DataCollectorService,
    private _utilityService: UtilityService,
    private recurringRouteService: RecurringRouteService,
    private titlecasePipe: TitleCasePipe,
    private dateTimePipe: DateTimePipe,
    private dateFormatPipe: DateFormatPipe,
    private timePipe: TimeFormatPipe,
  ) {
    this.updateTemplateMetaDataFromLocal();
    this.userRole = this._localStorageService.getLocalStorage('user')?.role.role_key || '';
  }

  updateTemplateMetaDataFromLocal(): any {
    this.metaData = this._dispatchBoardService.getLocalMetaData();
    return this.metaData
  }

  getJobRendererTemplate(tab: 'jobs' | 'routes', type: TemplateType, jobUid?: string, userUid?: string, additionalParams?: any): string {
    const gridData = this.metaData?.grid;
    const hideValues: any[] = [null, undefined, NaN, '',];
    const skipHideChecks: any[] = ['total_jobs'];
    let jobDetails: any;
    let gridRecords: any;
    let cardDetails: any = {};
    let startRowNumber: number = 1;
    let customSelectedAttributes: any;
    let displayAvatar: boolean;
    let employeeName: string = '';
    let primaryColor: string = '#e67e22';
    let secondaryColor: string = '#393a3c';
    let templateHtml: string = '';
    let primaryColorTooltip = '';
    let secondaryColorTooltip = '';
    let isRouteLocked = false;
    const skipAttributeIcon: any[] = [];
    const colorRep: any = {
      'jobStatus': this._utilityService.getLocaleValue('text.job_status'),
      'team': this._utilityService.getLocaleValue('text.team'),
      'jobCategory': this._utilityService.getLocaleValue('job.category'),
      'jobPriority': this._utilityService.getLocaleValue('text.job_priority'),
      'route': this._utilityService.getLocaleValue('text.route_color')
    };

    /* eslint-disable @typescript-eslint/naming-convention */
    if (jobUid && type === 'jobGridCard') {
      customSelectedAttributes = gridData?.card_view;
      startRowNumber = 2;
      if (tab === 'jobs') {
        gridRecords = this._dispatchBoardService.getGridRecords();
      }
      else if (tab === 'routes') {
        gridRecords = this._dispatchBoardService.getRouteTabGridRecords();
      }
      jobDetails = _.find(gridRecords, { 'job_uid': jobUid });
      cardDetails = this._dispatchBoardService.formatEventDetails(customSelectedAttributes, jobDetails);
      primaryColor = this.getCardColor(jobDetails, gridData?.primary_color);
      secondaryColor = this.getCardColor(jobDetails, gridData?.secondary_color);
      primaryColorTooltip = this.getGridColorTooltip(jobDetails, gridData?.primary_color);
      secondaryColorTooltip = this.getGridColorTooltip(jobDetails, gridData?.secondary_color);

    }
    else if (jobUid && type === 'routeGridCard') {
      const routeUid = jobUid;
      customSelectedAttributes = gridData?.route_card_view || [];
      const routeRecords = this._dispatchBoardService.getRouteTabRoutesRecord();
      const routeDetails = _.find(routeRecords, { 'route_uid': routeUid });
      isRouteLocked = routeDetails?.is_locked;
      cardDetails = this._dispatchBoardService.formatEventDetails(customSelectedAttributes, routeDetails);
      primaryColor = null;
      secondaryColor = routeDetails?.color || '#ffffff';;
      secondaryColorTooltip = colorRep['route'];
      startRowNumber = 2;
    }
    else if (jobUid && type === 'scheduler') {
      let schedulerRecords: any;
      if (tab === 'jobs') {
        schedulerRecords = this._dispatchBoardService.getSchedulerRecords();
        jobDetails = _.find(schedulerRecords, { 'job_uid': jobUid });
      }
      else if (tab === 'routes') {
        schedulerRecords = this._dispatchBoardService.getSchedulerRoutesRecords();
        const routeDetails = _.find(schedulerRecords, { 'jobs': [{ 'job_uid': jobUid }] });
        const routeJob: any = _.filter(routeDetails.jobs, { 'job_uid': jobUid });
        if (routeJob.length > 0) {
          jobDetails = routeJob[0]['job'];
        }
      }
      customSelectedAttributes = this.metaData?.scheduler?.card_view;
      if (this._utilityService.isEmptyOrUndefined(jobDetails)) {
        if (tab === 'jobs') {
          const _gridRecords = this._dispatchBoardService.getGridRecords();
          jobDetails = _.find(_gridRecords, { 'job_uid': jobUid });
        }
        else if (tab === 'routes') {
          const _gridRecords = this._dispatchBoardService.getRouteTabGridRecords();
          jobDetails = _.find(_gridRecords, { 'job_uid': jobUid });
        }
      }
      cardDetails = this._dispatchBoardService.formatEventDetails(customSelectedAttributes, jobDetails, additionalParams);
    }
    else if (userUid && type === 'employee') {
      let employeeRecords: any[];
      if (tab === 'jobs') {
        employeeRecords = this._dispatchBoardService.getJobTabEmployeeRecords();
      }
      else if (tab === 'routes') {
        employeeRecords = this._dispatchBoardService.getRouteTabEmployeeRecords();
      }
      const employeeMetaData = this.metaData?.employee;
      displayAvatar = employeeMetaData?.profile === 'with_avatar';
      customSelectedAttributes = employeeMetaData?.card_view;
      const employeeDetails = _.find(employeeRecords, { 'user_uid': userUid });
      cardDetails = this._dispatchBoardService.formatEmployeeDetails(customSelectedAttributes, employeeDetails, additionalParams);
      employeeName = employeeDetails?.name;
    }
    else if (!jobUid && type === 'tableProxy') {
      const _gridData = this.metaData?.grid;
      if (tab === 'jobs') {
        customSelectedAttributes = this.getTableProxyView(_gridData?.table_view);
      }
      else if (tab === 'routes') {
        if (additionalParams.selectedGridTab === 'JOBS') {
          customSelectedAttributes = this.getTableProxyView(_gridData?.table_view);
        }
        else if (additionalParams.selectedGridTab === 'ROUTES') {
          customSelectedAttributes = this.getTableProxyView(_gridData?.route_table_view);
        }
      }
      cardDetails = this._dispatchBoardService.getTableProxyRecords();
    }
    /* eslint-enable @typescript-eslint/naming-convention */
    if (!this._utilityService.isEmptyOrUndefined(customSelectedAttributes) && !this._utilityService.isEmptyOrUndefined(cardDetails)) {
      if (type === 'jobGridCard' || type === 'routeGridCard' || type === 'tableProxy') {
        let row = 1;
        let column = 0;
        let attribute = customSelectedAttributes[row][column];
        templateHtml += `<div class="w-full h-full min-w-72 font-normal space-y-2 text-base text-gray-700 dispatchTemplate m-auto p-3 bg-white border border-gray-200 cursor-pointer rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">`;

        if (type !== 'tableProxy') {
          templateHtml += `<div class='flex justify-between items-center'>`;
          templateHtml += `<div class='flex items-center truncate'>`;
          if (type === 'jobGridCard' && !cardDetails['isJobHasGeoCords']) {
            templateHtml += `<em title="${this._utilityService.getLocaleValue('dataPicker.job.geo_coordinates.alert_text', 'Geo Co-ordinates not found for this job')}" class="ti ti-map-pin-off text-xl text-red-700 mr-1"></em>`;
          }
          if (cardDetails['routeDetails']?.isRouteJob) {
            templateHtml += `<em title="${this._utilityService.getLocaleValue('dispatchBoard.template.grid.route_job')}: ${cardDetails['routeDetails']?.routeName}" class="ti ti-road text-2xl text-blue-700 mr-1"></em>`;
          }
          if (cardDetails['is_recurrence']) {
            templateHtml += `<em title="${this._utilityService.getLocaleValue('text.recurrent_job')}" class="ti ti-repeat text-2xl text-blue-700 mr-1"></em>`;
          }
          if (cardDetails['delayed_job']) {
            templateHtml += `<em title="${this._utilityService.getLocaleValue('text.delay_job')}" class="ti ti-alarm text-2xl text-red-700 mr-1"></em>`;
          }
          if (type === 'routeGridCard' && isRouteLocked) {
            templateHtml += `<em title="${this._utilityService.getLocaleValue('route.locked', 'Locked')}" class="ti ti-lock text-2xl text-red-700 mr-1"></em>`;
          }
          templateHtml += `<span title="${attribute.displayKeyValue} : ${cardDetails[attribute.key]}"
                  class="overflow-hidden whitespace-nowrap text-ellipsis w-fit">
                  ${cardDetails[attribute.key]}
                  </span>`;
          templateHtml += `</div>`;
          templateHtml += `<div class='flex'>`;
          templateHtml += `${type === 'jobGridCard' || type === 'routeGridCard' ? `<div class="flex items-center ml-1">
          ${gridData?.primary_color !== 'none' ? `<div class="w-3.5 h-3.5 mr-2" title='${colorRep[gridData?.primary_color]}: ${primaryColorTooltip}' style = "background-color: ${primaryColor}; ${!primaryColor ? 'display: none;' : ''}"></div>` : ''}
            ${secondaryColorTooltip ? `<div class="w-3.5 h-3.5 mr-2 rounded-full" title='${type === 'routeGridCard' ? `${colorRep['route']}` : `${colorRep[gridData?.secondary_color]}: ${secondaryColorTooltip}`}' style = "background-color: ${secondaryColor}; ${!secondaryColor ? 'display: none;' : ''}"></div>` : ''}
            </div>` : ''}`;

          templateHtml += `</div>`;
          templateHtml += `</div>`;
          if (type === 'jobGridCard') {
            row = 1;
            column = 1;
            attribute = customSelectedAttributes[row][column];
            templateHtml += `<div class='flex items-center'>`;
            templateHtml += `<span title="${attribute.displayKeyValue} : ${cardDetails[attribute.key]}"
          class="overflow-hidden whitespace-nowrap text-ellipsis w-fit primary-font font-normal text-base">
          ${cardDetails[attribute.key]}
          </span>`;
            templateHtml += `</div>`;
          }
        }

      }
      else if (type === 'employee') {
        templateHtml += `<div class='min-h-20 flex items-center'>`;
        if (displayAvatar) {
          if (cardDetails?.profile_picture.length > 0) {
            templateHtml += `<div class="mr-2 h-12 w-12 primary-font" title="${employeeName}">
          <img class="rounded-lg h-12 w-12" src="${cardDetails?.profile_picture}" alt="profile_picture" loading="lazy">
          </div>`;
          }
          else {
            templateHtml += `<div class="flex flex-0 items-center justify-center primary-font w-12 h-12 mr-2 rounded-lg overflow-hidden" title="${employeeName}">
          <div class="flex items-center justify-center w-full h-full rounded-md text-2xl uppercase bg-gray-200 dark:bg-gray-700 dark:text-gray-200 ng-star-inserted">
            ${employeeName?.slice(0, 1)} </div>
          </div>`;
          }
        }
        templateHtml += `<div class='ml-2 font-normal text-base text-gray-700 space-y-2'>`;
      }
      else if (type === 'scheduler') {
        templateHtml += `<div class='font-normal text-base text-gray-700 space-y-2'>`;
      }

      for (let row = startRowNumber; row <= Object.keys(customSelectedAttributes).length; row += 1) {
        templateHtml += `<div class='flex items-center gap-3 data-items primary-font'>`;
        _.forEach(customSelectedAttributes[row], (attribute: any, column: number) => {
          if ((!hideValues.includes(cardDetails[attribute.key]) && cardDetails[attribute.key]) || skipHideChecks.includes(attribute.group_uid)) {
            const isUnassignedJob = (attribute.group_uid === 'work_order_assigned_to' && cardDetails[attribute.key]['count'] < 0);
            templateHtml += `<div class='flex items-center ${isUnassignedJob ? 'hidden' : ''}' ${this.singletonRows.includes(attribute.key) || customSelectedAttributes[row].length === 1 ? `style='max-width: 100% !important'` : ''}>`;
            if (attribute.isDefaultField) {
              templateHtml += `<div class='flex items-center w-full'>`;
              if (!!attribute.icon) {
                if (attribute.group_uid === 'work_order_assigned_to') {
                  if (cardDetails[attribute.key]['count'] === 0) {
                    templateHtml += `<i class="ti ti-user text-xl mr-1"></i>`;
                  }
                  else if (cardDetails[attribute.key]['count'] >= 1) {
                    templateHtml += `<i class="ti ti-users text-xl mr-1"></i>`;
                  }
                }
                else if (attribute.group_uid === 'transport_mode') {
                  const modeOfTransport = cardDetails[attribute.key];
                  templateHtml += `<i class="${modeOfTransport === 'Car' ? 'ti ti-car' : modeOfTransport === 'Truck' ? 'ti ti-truck' : 'ti ti-walk'} text-xl mr-1"></i>`;
                }
                else if (attribute.group_uid === 'employee_job_count') {
                  templateHtml += `<i class="ti text-xl mr-1 ${tab === 'routes'? 'ti-route': 'ti-briefcase'}"></i>`;
                }
                else if (!skipAttributeIcon.includes(attribute.group_uid)) {
                  templateHtml += `<i class="${attribute.icon} text-xl mr-1"></i>`;
                }
              }
              switch (attribute.group_uid) {
                case 'current_work_order_status': {
                  const jobStatusBadge = {
                    type: cardDetails[attribute.key],
                    color: cardDetails['status_color_selector'],
                    displayName: cardDetails[attribute.key],
                    extraClass: 'w-inherit block-important w-max-fit'
                  };

                  templateHtml += this.getBadgeTemplate('badge', jobStatusBadge.displayName, jobStatusBadge.color);
                  break;
                }
                case 'work_order_skillsets':
                case 'employee_skillset':
                  {
                    templateHtml += `<div class='flex gap-2'>`;
                    if (cardDetails[attribute.key]['skill_name']) {
                      const skillsetBadge = {
                        displayKey: `${cardDetails[attribute.key]['skill_name']}` + (cardDetails[attribute.key]['skill_count']
                          ? ` + ${cardDetails[attribute.key]['skill_count']} ${this._utilityService.getLocaleValue('text.more')}`
                          : '')
                      };

                      templateHtml += `${this.getBadgeTemplate('tag', skillsetBadge.displayKey)}`;
                    }
                    templateHtml += `</div>`;
                    break;
                  }
                case 'work_order_assigned_to': {
                  templateHtml += `<div class='block truncate'>`;
                  if (cardDetails[attribute.key] && cardDetails[attribute.key]['count'] >= 0) {
                    templateHtml += `<span title='${attribute.displayKeyValue}: ${cardDetails[attribute.key]['name']}${cardDetails[attribute.key]['count'] > 0 ? ` +${cardDetails[attribute.key]['count']} ${this._utilityService.getLocaleValue('text.more', 'more')}` : ''}'>${cardDetails[attribute.key]['name']}</span>`;
                  }
                  if (cardDetails[attribute.key]['count'] > 0) {
                    templateHtml += `<span class='ml-2' title="+${cardDetails[attribute.key]['count']} ${this._utilityService.getLocaleValue('text.more', 'more')}">+${cardDetails[attribute.key]['count']} ${this._utilityService.getLocaleValue('text.more', 'more')}</span>`;
                  }
                  templateHtml += `</div>`;
                  break;
                }
                case 'employee_work_hours': {
                  templateHtml += `<div class="flex gap-2">
                <span class="primary-font font-normal text-base" title="${attribute.displayKeyValue}">${cardDetails[attribute.key]['start_time']} - ${cardDetails[attribute.key]['end_time']}</span>
                </div>`;
                  break;
                }
                case 'work_order_priority': {
                  const priorityColor = badgeColorCode[cardDetails[attribute.key]] || '#ffffff';
                  templateHtml += `<div class ='flex items-center gap-1 border border-gray-300 rounded-2xl py-1 px-2'><div class='w-3 h-3 rounded' style='background-color:${priorityColor};'></div>
                  <span class='overflow-hidden whitespace-nowrap text-ellipsis w-fit' title="${attribute.displayKeyValue} : ${this.titlecasePipe.transform(cardDetails[attribute.key])}">${this.titlecasePipe.transform(cardDetails[attribute.key])}</span></div>`;
                  break;
                }
                case 'work_order_actual_date':
                case 'work_order_scheduled_date': {
                  if (cardDetails[attribute.key]) {
                    let formatedDate: string = '';
                    if (cardDetails[attribute.key]['startDateTime']) {
                      formatedDate += cardDetails[attribute.key]['startDateTime'];
                      if (cardDetails[attribute.key]['endDateTime']) {
                        formatedDate += ' -> ' + cardDetails[attribute.key]['endDateTime'];
                      }
                      templateHtml += `<div class="flex gap-2 text-gray-700 overflow-hidden whitespace-nowrap text-ellipsis primary-font font-normal text-base w-fit"><span title="${attribute.displayKeyValue} : ${formatedDate}"
                      class="block items-center overflow-hidden whitespace-nowrap text-ellipsis w-fit">${cardDetails[attribute.key]['startDateTime']}${cardDetails[attribute.key]['endDateTime'] ? `<i class='ti ti-arrow-narrow-right text-xl mx-1 relative top-0.5'></i>${cardDetails[attribute.key]['endDateTime']}` : ``}</div>`;
                    }
                  }
                  break;
                }
                case 'total_jobs': {
                  templateHtml += `<span title="${tab === 'routes' ? `${this._utilityService.getLocaleValue('text.routes', 'Routes')}` : `${attribute.displayKeyValue} : ${cardDetails[attribute.key]}`}"
                    class="font-normal text-gray-700 overflow-hidden whitespace-nowrap text-ellipsis primary-font text-base w-fit">
                    ${cardDetails[attribute.key]}</span>`;
                  break;
                }
                case 'job_tags': {
                  if (cardDetails[attribute.key]?.length) {
                    let extraTagCount: number = 0;
                    const tagsFormatted = cardDetails[attribute.key]?.join(', ');
                    if (cardDetails[attribute.key]?.length > 1) {
                      extraTagCount = cardDetails[attribute.key]?.length - 1;
                    }
                    templateHtml += `<div class='p-1.5 w-fit truncate block text-base rounded bg-gray-200 text-gay-700' title="${attribute.displayKeyValue}: ${tagsFormatted}">${cardDetails[attribute.key][0]} ${extraTagCount ? `+ ${extraTagCount} ${this._utilityService.getLocaleValue('text.more')}`: ''}</div>`;
                  }
                  break;
                }
                default: {
                  if (attribute.group_uid === 'employee_job_count' && tab === 'routes') {
                    templateHtml += `<span title="${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.summary.total_routes', 'Total route')}"
                class="${(row === 1 && column === 0 && type === 'employee') ? 'font-semibold text-base' : 'font-normal'} primary-font text-base font-normal text-gray-700 overflow-hidden whitespace-nowrap text-ellipsis w-fit">
                ${cardDetails[attribute.key]}
                </span>`;
                  }
                  else {
                    if (attribute.group_uid === 'work_order_title' && cardDetails['routeDetails']?.isRouteJob) {
                      templateHtml += `<em title="${this._utilityService.getLocaleValue('dispatchBoard.template.grid.route_job')}: ${cardDetails['routeDetails'].routeName}" class="ti ti-road text-2xl text-blue-700 mr-2"></em>`;
                    }
                    if (attribute.group_uid === 'work_order_title' && cardDetails['is_recurrence']) {
                      templateHtml += `<em title="${this._utilityService.getLocaleValue('text.recurrent_job')}" class="ti ti-repeat text-2xl text-blue-700 mr-2"></em>`;
                    }
                    if (attribute.group_uid === 'work_order_title' && cardDetails['delayed_job']) {
                      templateHtml += `<em title="${this._utilityService.getLocaleValue('text.delay_job')}" class="ti ti-alarm text-2xl text-red-700 mr-2"></em>`;
                    }
                    templateHtml += `<span title="${attribute.displayKeyValue} : ${cardDetails[attribute.key]}"
                    class="${(row === 1 && column === 0 && type === 'employee') ? 'font-semibold text-base' : 'font-normal'} primary-font text-base font-normal text-gray-700 overflow-hidden whitespace-nowrap text-ellipsis w-fit">
                    ${cardDetails[attribute.key]}
                    </span>`;
                  }
                }
              }
              templateHtml += `</div>`;
            }
            else {
              templateHtml += `${cardDetails[attribute.key]['href'] ?
                `<span class='overflow-hidden whitespace-nowrap text-ellipsis w-fit primary-font font-normal text-base' title="${attribute.displayKeyValue}"'> <a class="w-10/12 text-justify text-primary-500 hover:underline font-normal text-base" 
             href="${cardDetails[attribute.key]['href']}" onclick="event.stopPropagation()" target="_blank">${attribute.type === 'LOOKUP' ? cardDetails[attribute.key]['value'] : this._utilityService.getLocaleValue('dispatch.template.field.view_link')}</a></span>` :
                `<span class="overflow-hidden whitespace-nowrap text-ellipsis w-fit primary-font font-normal text-base" title="${attribute.tooltip}: ${cardDetails[attribute.key]}"> ${cardDetails[attribute.key]}</span>`
                }`;
            }
            templateHtml += `</div>`;
          }
        });
        templateHtml += '</div>';
      }

      templateHtml += '</div>';
    }
    else {
      templateHtml = '';
    }
    return templateHtml;
  }

  getNonJobEventRendererTemplate(nonJobEventDetails: any): any {
    const eventName: string = nonJobEventDetails?.event_name || '';
    const startEndTime: any[] = this._dispatchBoardService.getStartEndTime(nonJobEventDetails?.start_time, nonJobEventDetails?.end_time, false, null, true);
    const categoryColor: string = nonJobEventDetails?.event_category?.category_color || '#e67e22';
    const availabilityFree: boolean = nonJobEventDetails?.is_available;
    const isRecurrence: boolean = nonJobEventDetails?.is_recurrence;
    let templateHTML: string = '';
    templateHTML += `<div class="w-full h-full text-gray-700 pr-1">
    <div class="flex w-full h-full items-center">
      <div class="h-full w-2 flex-0" style="${availabilityFree ? `background-image: linear-gradient(135deg, ${categoryColor} 25%, #ffffff 25%, #ffffff 50%, ${categoryColor} 50%, ${categoryColor} 75%, #ffffff 75%, #ffffff 100%); background-size: 11.31px 11.31px`: `background: ${categoryColor}`}"></div>
      <div class="w-full h-full primary-font text-base font-normal space-y-1.5 pl-2 pt-1 pr-2">
        <div class="flex items-center space-x-1.5 truncate" title="${this._utilityService.getLocaleValue('non_job_event.create.name')}: ${eventName}">
          <span class="block truncate">${eventName}</span>
          ${isRecurrence? `<div class='min-w-fit'><i class="ti ti-repeat text-2xl" style='color: #0172CB' title="${this._utilityService.getLocaleValue('text.recurrence_event')}"></i></div>`: ''}
        </div>
        <div class="flex items-center space-x-1.5 w-full truncate" title="${this._utilityService.getLocaleValue('text.event_schedule')}: ${startEndTime[0]} -> ${startEndTime[1]}">
          <i class="ti ti-calendar-time text-2xl"></i>
          <span class="flex-0">${startEndTime[0]}</span>
          <i class="ti ti-arrow-right text-2xl"></i>
          <span class="flex-1 block truncate">${startEndTime[1]}</span>
        </div>
      </div>
    </div>
  </div>`;
    return templateHTML;
  }

  getCardShimmer(): string {
    return `<div class="p-4 w-full border rounded-lg shadow bg-white m-1 mb-2">
  <div class="animate-pulse flex space-x-4">
    <div class="flex-1 space-y-4 py-1">
      <div class="space-y-4">
        <div class="grid grid-cols-3 gap-4">
          <div class="h-4 bg-gray-200 rounded col-span-2"></div>
          <div class="h-4 bg-gray-200 rounded col-span-1"></div>
        </div>
      <div class="h-4 bg-gray-200"></div>
        <div class="h-4 bg-gray-200 rounded"></div>
        <div class="grid grid-cols-3 gap-4">
          <div class="h-4 bg-gray-200 rounded col-span-1"></div>
          <div class="h-4 bg-gray-200 rounded col-span-2"></div>
        </div>
      </div>
    </div>
  </div>
</div>`;
  }

  getUserCardShimmer(): string {
    return `<div class="w-full bg-white">
   <div class="animate-pulse flex w-full flex-col">
      <div class="flex w-full space-x-1.5">
         <div class="h-12 w-13 min-w-fit rounded bg-gray-200"></div>
         <div class="flex flex-col space-y-2.5 w-full">
            <div class="h-4 w-full rounded bg-gray-200"></div>
            <div class="flex gap-2">
              <div class="h-4 w-full rounded bg-gray-200"></div>
              <div class="h-4 w-full rounded bg-gray-200"></div>
            </div>
         </div>
      </div>
   </div>
</div>`;
  }

  getTableShimmer(): string {
    return `<div class="animate-pulse flex space-x-4 m-2 w-full">
    <div class="flex-1 space-y-4 py-1">
      <div class="space-y-4">
        <div class="h-5 bg-gray-200 rounded"></div>
      </div>
    </div>
  </div>`;
  }

  getBadgeTemplate(type: 'badge' | 'tag', displayName: string, color?: string, extraClass?: string): string {
    if (!type || !displayName) { return ''; }
    if (type === 'badge') {
      const backgroundColor: string = this._utilityService.convertHexToRgba(color);
      return `<div class="truncate w-inherit block-important w-max-fit min-w-fit">
        <div class="border p-0.5 px-2.5 w-inherit inline-block truncate ${extraClass ? extraClass : 'rounded-2xl'}" title="${displayName}" style="color: ${color}; background: ${backgroundColor}; border-color: ${color}">${displayName}</div>
      </div>`;
    }
    else if (type === 'tag') {
      return `<div class="truncate w-inherit block-important w-max-fit min-w-fit">
        <div class="border p-1 px-2.5 w-inherit inline-block truncate rounded bg-gray-200 text-gray-700" title="${displayName}">${displayName}</div>
      </div>`;
    }
  }

  getTimeoffTooltipTemplate(userDetails: any, timeoffDetails: any): string {
    const employeeName = userDetails?.name;
    const profileUrl = userDetails?.imageUrl;
    const contactNumber = userDetails?.work_phone_number || userDetails?.home_phone_number || userDetails?.mobile_phone_number;
    const emailId = userDetails?.email;
    const role = timeoffDetails?.role;
    const userRole = this.userRole;
    const [timeoffRequestedFrom, timeoffRequestedfromTo] = this._dispatchBoardService.getStartEndTime(timeoffDetails?.actualRequestFrom, timeoffDetails?.actualRequestTo, true);
    const status = timeoffDetails?.status;
    const reason = timeoffDetails?.reason;
    const remarks = timeoffDetails?.remarks;
    const hasPermissionToEditTimeoff = userRole === 'ADMIN' || this._utilityService.hasPermission('timesheet.manage_timeoff') || this._utilityService.user?.user_uid === timeoffDetails?.requestedBy?.user_uid;
    let templateHtml = `<div class="w-full h-full overflow-hidden"> <div class="flex items-center justify-between mb-2"><div class="flex justify-center items-center gap-2">`;
    if (this._utilityService.hasValidProfilePicture(profileUrl)) {
      templateHtml += `<div class="mr-2 h-16 w-16" title="${employeeName}">
    <img class="rounded-lg h-16 w-16" src="${profileUrl}" alt="profile_picture" loading="lazy">
    </div>`;
    }
    else {
      templateHtml += `<div class="flex flex-0 items-center justify-center w-16 h-16 rounded-full overflow-hidden" title="${employeeName}">
    <div class="flex items-center justify-center w-full h-full rounded-md text-2xl uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 ng-star-inserted">
      ${employeeName?.slice(0, 1)} </div>
    </div>`;
    }
    templateHtml += `<div class='grid gap-0.5'><span class="font-medium tracking-wide text-lg">${employeeName}</span><span class="text-base text-gray-400">${role}</span></div></div><div class='flex gap-1'>`;
    if (contactNumber) {
      templateHtml += `<div class="flex gap-1"><a type='button' href='tel:${contactNumber}' class="text-lg font-normal text-gray-800 flex items-center justify-center gap-1 hover:bg-gray-100 rounded-lg h-8 w-8" title='${this._utilityService.getLocaleValue('text.call', 'Call')}'><i class="ti ti-phone text-xl font-normal"></i></a></div>`;
    }
    if (!this._utilityService.isEmptyOrUndefined(emailId)) {
      templateHtml += `<div class="flex gap-1"><a type='button' href='mailto:${emailId}' class="text-lg font-normal text-gray-800 flex items-center justify-center gap-1 hover:bg-gray-100 rounded-lg h-8 w-8" title='${this._utilityService.getLocaleValue('email', 'Email')}'><i class="ti ti-mail text-xl font-normal"></i></a></div>`;
    }
    templateHtml += `</div></div><hr>`;
    templateHtml += `<div class='w-full pt-2 flex justify-between items-center'><span class='text-base font-semibold text-gray-700 tracking-wide'>${this._utilityService.getLocaleValue('dispatchBoard.scheduler.timeoff.tooltip.details')}</span>`;
    if (hasPermissionToEditTimeoff) {
      templateHtml += `<div class='flex gap-1'>`;
      templateHtml += `<div class='flex items-center justify-center cursor-pointer text-blue-600 text-lg font-normal gap-1 hover:bg-gray-100 rounded-lg h-8 w-8' id='timeoff_edit' title='${this._utilityService.getLocaleValue('edit.time.off.dialog.title', 'Edit Timeoff request')}'><i class="ti ti-pencil mr-0.5 text-xl font-normal"></i></div>`;
      templateHtml += `<div class='flex items-center justify-center cursor-pointer text-red-600 text-lg font-normal gap-1 hover:bg-gray-100 rounded-lg h-8 w-8' id='timeoff_delete' title='${this._utilityService.getLocaleValue('timeoff.delete.dialog.title', 'Delete Timeoff request')}'><i class="ti ti-trash mr-0.5 text-xl font-normal"></i></div>`;
      templateHtml += `</div>`;
    }
    templateHtml += '</div>';
    templateHtml += `<div class="flex flex-col justify-content my-2 space-y-2">
    <div class="flex flex-wrap items-center flex-row "><i class="ti ti-calendar text-2xl"></i>
    <div class="text-base mt-1 ml-1 flex items-center"><span>${timeoffRequestedFrom}</span><em class="ti ti-arrow-narrow-right text-xl mx-1"></em><span>${timeoffRequestedfromTo}</span></div></div>`;

    if (!this._utilityService.isEmptyOrUndefined(status)) {
      const timeoffStatusBadgeConfig = {
        color: badgeColorCode[status],
        displayName: this.titlecasePipe.transform(status)
      };
      templateHtml += `<div class="flex flex-row gap-4">
      <span class="w-1/4 text-base font-medium">${this._utilityService.getLocaleValue('status.text', 'Status')}</span>
      <span class="w-full text-base">${this.getBadgeTemplate('badge', timeoffStatusBadgeConfig.displayName, timeoffStatusBadgeConfig.color)}</span>
      </div>`;
    }
    if (!this._utilityService.isEmptyOrUndefined(reason)) {
      templateHtml += `<div class="flex flex-row gap-4"><span class="w-1/4 text-base font-medium">${this._utilityService.getLocaleValue('text.Reason', 'Reason')}</span>
      <span class="w-full text-base">${this.titlecasePipe.transform(reason)}</span></div>`;
    }
    if (!this._utilityService.isEmptyOrUndefined(remarks)) {
      templateHtml += `<div class="flex flex-row gap-4"><span class="w-1/4 text-base font-medium">${this._utilityService.getLocaleValue('text.remarks', 'Remarks')}</span>
      <span class="w-full text-base multiline-ellipsis">${remarks}</span></div>`;
    }

    templateHtml += `</div></div>`;
    return templateHtml;
  }

  getSchedulerSummaryTooltip(type: 'job' | 'route', resoureAssignments: any, totalEvents: number): string {
    let schedulerTitle: string = '';
    let schedulerSubTitle: string = '';
    if (type === 'job') {
      schedulerTitle = this._utilityService.getLocaleValue('text.job_summary', 'Job Summary');
      schedulerSubTitle = this._utilityService.getLocaleValue('text.total_jobs', 'Total Jobs');
    }
    else if (type === 'route') {
      schedulerTitle = this._utilityService.getLocaleValue('text.route_summary', 'Route Summary');
      schedulerSubTitle = this._utilityService.getLocaleValue('dispatchBoard.scheduler.job.summary.total_routes', 'Total Routes');
    }
    let templateHtml = '';
    templateHtml += `<div class="w-full h-full cursor-pointer">
      <div class="space-y-2">
          <div class="pb-1 font-semibold text-lg border-b border-gray-300">${schedulerTitle}</div>
          <div class="flex items-center cursor-pointer space-x-1">
              <div class="font-medium text-lg">${schedulerSubTitle} :</div> <span class="text-lg font-normal ">${totalEvents}</span>
          </div>`;
    Object.keys(resoureAssignments).forEach((user: any) => {
      templateHtml += `<div class="flex items-center text-lg font-normal space-x-1">`;
      templateHtml += `<i class="text-xl ti ti-user"></i><span>${user} :</span><span>${resoureAssignments[user]}</span>`;
      templateHtml += `</div>`;
    });
    templateHtml += `</div>`;
    templateHtml += `</div>`;
    return templateHtml;
  }

  getNonJobEventTooltip(nonJobEventDetails: any): string {
    let templateHTML: string = '';
    if (nonJobEventDetails) {
      const eventName: string = nonJobEventDetails?.event_name || '';
      const startEndTime: any[] = this._dispatchBoardService.getStartEndTime(nonJobEventDetails?.start_time, nonJobEventDetails?.end_time, false, null);
      const timezoneBasedStartEndTime: any[] = this._dispatchBoardService.getStartEndTime(nonJobEventDetails?.start_time, nonJobEventDetails?.end_time, false, null, false, false, nonJobEventDetails?.timezone);
      const timezoneCode: string = `GMT ${moment().tz(nonJobEventDetails?.timezone).format('Z')}`;
      const categoryColor: string = nonJobEventDetails?.event_category?.category_color || '#e67e22';
      const categoryName: string = nonJobEventDetails?.event_category?.category_name || '';
      const availabilityFree: boolean = nonJobEventDetails?.is_available;
      const eventAddress: string = this.getCityAddress(nonJobEventDetails?.event_address);
      const isRecurrence: boolean = nonJobEventDetails?.is_recurrence;
      const recurrenceText: string = isRecurrence ? nonJobEventDetails?.recurrence?.rrule ? this._utilityService.getRruleText(nonJobEventDetails?.recurrence?.rrule, this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]) : '': '';
      templateHTML += `
      <div class="w-full h-full">
        <div class="flex flex-col primary-font text-base fornt-normal text-gray-700">
          <div class="flex justify-between items-center space-x-1 truncate bg-gray-100 p-2 border-b border-gray-200">
            <span class="truncate block text-gray-500 font-medium">${eventName}</span>
            ${isRecurrence? `<i class="ti ti-repeat text-2xl" style="color: #0172CB"></i>`: ''}
          </div>
          <div class="flex flex-col space-y-3 primary-font text-base fornt-normal text-gray-700 p-3">
            <div class="flex flex-col space-y-1">
              <div class="flex items-start space-x-1.5">
                <i class="ti ti-calendar text-2xl"></i>
                <span>${startEndTime[0]}</span>
                <i class="ti ti-arrow-right text-2xl"></i>
                <span>${startEndTime[1]}</span>
              </div>
              <div class="flex items-start space-x-1.5 ml-6">
                (<span>${timezoneBasedStartEndTime[0]}</span>
                <i class="ti ti-arrow-right text-2xl"></i>
                <span>${timezoneBasedStartEndTime[1]} ${timezoneCode}</span>)
              </div>
            </div>
            ${isRecurrence? `<div class="flex items-start space-x-1.5">
              <i class="ti ti-repeat text-2xl"></i>
              <span>${this._utilityService.getLocaleValue('text.repeats')} ${recurrenceText}</span>
            </div>`: ''}
            <div class="flex items-start space-x-1.5">
              <i class="ti ti-layout-grid text-2xl"></i>
              <span>${categoryName}</span>
            </div>
            ${eventAddress ? `<div class="flex items-start space-x-1.5">
              <i class="ti ti-map-pin text-2xl"></i>
              <span>${eventAddress}</span>
            </div>`: ''}
            <div class="flex items-start space-x-1.5">
              <div class="w-2 h-6 mx-1.5 flex-0 border" style="${availabilityFree ? `background-image: linear-gradient(135deg, ${categoryColor} 25%, #ffffff 25%, #ffffff 50%, ${categoryColor} 50%, ${categoryColor} 75%, #ffffff 75%, #ffffff 100%); background-size: 11.31px 11.31px`: `background: ${categoryColor}`}; border-color: ${categoryColor}"></div>
              <span>${availabilityFree? this._utilityService.getLocaleValue('non_job_event.create.availability.free'): this._utilityService.getLocaleValue('non_job_event.create.availability.busy')}</span>
            </div>
          </div>
        </div>
      </div>
      `;
    }
    return templateHTML;
  }

  getSchedulerResourceHeader(filterCount: number, tab: string): string {
    const templateHtml = `<div class="w-full h-full pt-2 text-gray-700" id="schedulerResourceHeader-${tab}">
    <div class="flex items-center justify-between space-x-4">
        <div class="flex pl-2">
            <span class="text-xl font-medium">${this._utilityService.getLocaleValue('text.users', 'Users')}</span>
        </div>
        <div class="flex ml-3">
            <button title="${this._utilityService.getLocaleValue('text.search', 'Search')}" id='schedulerEmpHeaderSearchBtn-${tab}' class="icon-button"><i class="ti ti-search text-2xl"></i></button>
            <button  title="${this._utilityService.getLocaleValue('text.filters', 'Filters')}" id='schedulerEmpHeaderFilterBtn-${tab}' class="icon-button relative items-center"><i class="ti ti-filter text-2xl"></i>
            <div id="employeeFilterBadge-${tab}" class="absolute inline-flex items-center opacity-0 justify-center w-6 h-6 text-xs font-bold text-white bg-primary-600 border-2 border-white rounded-full top-0 -right-2 dark:border-gray-900">${filterCount}</div>
            </button>
            <button title="${this._utilityService.getLocaleValue('text.sort', 'Sort')}" id='schedulerEmpHeaderSortBtn-${tab}' class="icon-button"><i class="ti ti-arrows-sort text-2xl"></i></button>
            <button title="${this._utilityService.getLocaleValue('text.settings', 'Settings')}" id='schedulerEmpHeaderSettingsBtn-${tab}' class="icon-button"><i class="ti ti-settings text-2xl"></i></button>
        </div>
      </div>
    </div>`;
    return templateHtml;
  }

  getOutOfShiftHoursTooltip(shiftDetails: any): string {
    let templateHtml = ` <div>
        <div class="h-5 p-4 mb-2 flex items-center justify-center border-b border-gray-300">
            <span class="text-base font-medium">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.out_of_shift_hours.tooltip.title', 'Out of Shift Hours')}</span>
        </div>
        <div class="flex flex-col space-y-2">
            <span class="text-base font-medium">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.out_of_shift_hours.tooltip.details', 'Shift details')}</span>`;
    shiftDetails.forEach((shiftDetail: any, index: number) => {
      const shiftLabel = shiftDetail[0];
      const [startDateTime, endDateTime] = this._dispatchBoardService.getStartEndTime(shiftDetail[1], shiftDetail[2], true);
      templateHtml += `<div class="flex items-center space-x-1"><i class="ti ti-calendar-stats text-2xl"></i>
                <span class="text-base font-normal" title="${this._utilityService.getLocaleValue('dispatchBoard.scheduler.out_of_shift_hours.tooltip.shift_name', 'Shift Name')}">${shiftLabel}</span></div>
                <div class="text-base font-normal flex items-center" title="${this._utilityService.getLocaleValue('text.shift_hours', 'Shift Hours')}"><i class="ti ti-clock text-2xl mr-1"></i><span>${startDateTime}</span> <i class='ti ti-arrow-narrow-right text-xl mx-1'></i><span> ${endDateTime}</span></div> ${index !== shiftDetails.length - 1 ? '<hr>' : ''}`;
    });
    templateHtml += `</div>`;
    return templateHtml;
  }

  getJobDetailsTemplate(jobDetails: any, view: string, metaData: any, showAssignedTo: boolean = false, additionalParam?: any): any {
    if (!jobDetails) {
      return '';
    }
    const badgeOption: any = jobDetails.current_job_status ? {
      color: jobDetails.current_job_status?.status_color ?? badgeColorCode[jobDetails?.current_job_status?.status_type] ?? null,
      displayName: jobDetails.current_job_status?.status_name,
      extraClass: 'capitalize'
    } : null;
    const cityAddress: string = this.getCityAddress(jobDetails.customer_address);
    const [scheduledStartDate, scheduledEndDate] = this._dispatchBoardService.getStartEndTime(jobDetails?.scheduled_start_time, jobDetails?.scheduled_end_time, false);
    const [scheduledStartDateWithTz, scheduledEndDateWithTz] = jobDetails?.job_timezone ? this._dispatchBoardService.getStartEndTime(jobDetails?.scheduled_start_time, jobDetails?.scheduled_end_time, false, null, false, false, jobDetails?.job_timezone) : ['', ''];
    const timezoneFormatted: string = jobDetails?.job_timezone ? `GMT ${moment().tz(jobDetails?.job_timezone).format('Z')}`: '';
    const [actualStartDate, actualEndDate] = this._dispatchBoardService.getStartEndTime(jobDetails?.actual_start_time, jobDetails?.actual_end_time, false);
    const assignedTo = jobDetails?.assigned_to || [];
    const maxAssigedToprofile: number = 4;
    let templateHTML = `<div class="flex flex-col space-y-2 job-preview-panel primary-font w-full ${showAssignedTo && assignedTo?.length ? 'p-4 pb-1' : 'p-4'}">
      <div class="text-base font-bold flex py-1.5 items-center">
          ${jobDetails?.route?.route_uid ? `<span class="flex items-center mr-2">
              <em class="ti ti-road text-xl text-blue-700"></em>
          </span>` : ''}
          ${jobDetails.is_recurrence === true ? `<span class="flex items-center mr-2">
              <em class="ti ti-repeat text-xl text-blue-700"></em>
          </span>` : ''}
          ${jobDetails.delayed_job === true ? `<span class="flex items-center mr-2">
              <em class="ti ti-alarm text-xl text-red-700"></em>
          </span>` : ''}
          <span id='job-title'>#${jobDetails.prefix ?? ''}${jobDetails.work_order_number} ${jobDetails.job_title}</span>
          ${additionalParam?.showRouteJobNumber ? `<div class="w-7 h-7 min-w-7 min-h-7 flex items-center justify-center rounded-full border shadow ml-1" style="background-color: ${additionalParam?.color}; border-color: ${this._utilityService.getTextColorBasedOnBg(additionalParam?.color)}"; color: ${this._utilityService.getTextColorBasedOnBg(additionalParam?.color)};>${additionalParam?.jobCount}</div>` : ''}
      </div>
      ${jobDetails.job_category ? `<div class="text-base flex">
          <span class="flex items-center mr-2">
              <em class="ti ti-category text-xl"></em>
          </span>
          <div class="text-base flex items-center space-x-2">
           <span>  ${jobDetails.job_category?.category_name}</span>
            ${jobDetails.current_job_status ? `${this.getBadgeTemplate('badge', badgeOption?.displayName, badgeOption?.color, 'rounded captalize')}` : ''}
          </div>
      </div>` : ''}
  
      ${jobDetails?.scheduled_start_time && jobDetails?.scheduled_end_time ? `<div class="text-base flex">
          <span class="flex mt-0.5 mr-2">
              <em class="ti ti-calendar text-xl"></em>
          </span>
          <div class="text-base flex flex-wrap items-center">
          ${scheduledStartDate}<em class="ti ti-arrow-narrow-right text-xl mx-1"></em>${scheduledEndDate}
            ${jobDetails?.job_timezone ? `<span class='flex items-center flex-wrap'>
              (${scheduledStartDateWithTz}<em class="ti ti-arrow-narrow-right text-xl mx-1"></em>${scheduledEndDateWithTz} ${timezoneFormatted})
          </span>` : ''}
          ${jobDetails.actual_start_time && jobDetails.actual_end_time ? `<span>
              (${this._utilityService.getLocaleValue('job.details.popup.actual_time', 'Actual')} : ${actualStartDate}<em class="ti ti-arrow-narrow-right text-xl mx-1"></em>${actualEndDate})
          </span>` : ''}
          </div>
      </div>` : ''}
  
      ${jobDetails.due_date ? `<div class="text-base flex">
          <span class="flex items-center mr-2">
              <em class="ti ti-clock-hour-5 text-xl"></em>
          </span>
          ${this._utilityService.getLocaleValue('text.due_by', 'Due By')} : ${this.dateFormatPipe.transform(jobDetails.due_date)}
      </div>` : ''}

      ${jobDetails?.project && this._dispatchBoardService.moduleAccess.project ? `<div class="text-base flex">
          <span class="flex items-center mr-2">
            <em class="ti ti-clipboard-check text-xl"></em>
          </span>
          ${this._utilityService.getLocaleValue('Project', 'Project')} : ${this._dispatchBoardService.getJobTitle(jobDetails?.project?.project_prefix, jobDetails?.project?.project_number, jobDetails?.project?.project_name)}
      </div>` : ''}
    
      ${jobDetails?.route && typeof(jobDetails?.route) !=='string' && view === 'DAY' && metaData?.map?.enable_map_view ? `<div class="text-base flex">
          <span class="flex items-center mr-2">
              <em class="ti ti-route text-xl"></em>
          </span>
          <div class="text-base flex items-center">
          ${this._utilityService.getLocaleValue('text.route', 'Route')} : ${jobDetails.route?.color ? `<span class="w-3.5 h-3.5 rounded mx-1" style="background:${jobDetails.route?.color};"></span>` : ''}${jobDetails.route?.route_name}
          </div>
      </div>` : ''}
  
      ${jobDetails.customer ? `<div class="text-base flex">
          <span class="flex items-center mr-2">
              <em class="ti ti-user text-xl"></em>
          </span>
          ${jobDetails.customer.customer_first_name + ' ' + (jobDetails.customer.customer_last_name || '')}
          ${jobDetails.customer.customer_organization ? `<span class="ml-1">(${jobDetails.customer.customer_organization.organization_name})</span>` : ''}
      </div>` : ''}
  
      ${!jobDetails.customer && jobDetails.organization ? `<div class="text-base flex">
          <span class="flex items-center mr-2">
              <em class="ti ti-building text-xl"></em>
          </span>
          ${jobDetails.organization?.organization_name}
      </div>` : ''}
  
      ${jobDetails.customer_address?.street ? `<div class="text-base flex">
          <span class="flex mt-0.5 mr-2">
              <em class="ti ti-map-pin text-xl"></em>
          </span>
          ${this._utilityService.getUniqueStreetValue(jobDetails.customer_address)}
      </div>` : ''}
  
      ${cityAddress ? `<div class="text-base flex">
          <span class="flex mt-0.5 mr-2">
              <em class="ti ti-location text-lg"></em>
          </span>
          ${cityAddress}
      </div>` : ''} 
  
      </div>`;
    if (showAssignedTo && assignedTo?.length) {
      if (assignedTo?.length) {
        templateHTML += `<div class='flex items-center bg-gray-100 p-2 rounded-b-lg'>`;
        assignedTo?.slice(0, maxAssigedToprofile).forEach((assignee: any, index: number) => {
          const profilePicture = assignee?.user?.profile_picture;
          const userName = this._utilityService.concatTwoStrings(assignee?.user?.first_name, assignee?.user?.last_name) || assignee?.team?.team_name || '';
          if (profilePicture && userName && this._utilityService.hasValidProfilePicture(profilePicture)) {
            templateHTML += `<img class="h-6 w-6 relative rounded-full ring-2 ring-white" loading="lazy" src="${profilePicture}" alt="${userName}" title="${userName}" style="left: -${index * 5}px; z-index: ${maxAssigedToprofile - index};">`;
          }
          if (userName && !this._utilityService.hasValidProfilePicture(profilePicture)) {
            templateHTML += `<div title="${userName}" class="flex relative items-center justify-center h-6 w-6 rounded-full overflow-hidden" style="left: -${index * 5}px; z-index: ${maxAssigedToprofile - index};">
            <div class="flex items-center justify-center h-6 w-6 ring-2 ring-white rounded-full uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200 ng-star-inserted"> ${userName.slice(0, 1)}</div>
          </div>`;
          }
        });
        if (assignedTo?.length > maxAssigedToprofile) {
          templateHTML += `<span class='primary-font p-1 bg-white flex items-center justify-center relative text-sm h-6 w-6 rounded-full text-gray-700 ml-2' style="left: -${maxAssigedToprofile * 4}px"> +${assignedTo?.length - maxAssigedToprofile}</span>`;
        }
        templateHTML += `</div>`;
      }
    }
    return templateHTML;
  }

  async getEmployeePreviewTemplate(tab: 'jobs' | 'routes', dateRange: { fromDate: string; toDate: string } = null, userDetails: any = null, preferences: any = null, eventCount: any = null, viewMode: string = null): Promise<string> {
    this.dateRange = dateRange;
    this.userDetails = userDetails;
    this.preferences = preferences;
    this.viewMode = viewMode;
    this.fieldsVisibility = this.preferences?.display;
    const userUid = this.userDetails?.user_uid;
    let workMins: number;
    let availableMins: number;
    if (this.viewMode === 'DAY' && this.fieldsVisibility?.capacity) {
      [workMins, availableMins] = await this.getUserCapacity(userUid, dateRange.fromDate, dateRange.toDate);
    }
    this.updateTimeSheetValue();
    this.updateCapacityHours(workMins, availableMins);

    let templateHtml = '';
    if (!this._utilityService.isEmptyOrUndefined(this.userDetails)) {
      templateHtml += `<div class="flex flex-col employee-preview-panel primary-font ${userDetails?.user_shifts?.length ? 'w-[400px]':''}">`;
      templateHtml += `<div>
    <div class="flex items-center pb-3 border-b">
        <div class="inline-flex overflow-hidden rounded-md flex-shrink-0">`;
      if (this._utilityService.hasValidProfilePicture(userDetails.profile_picture)) {
        templateHtml += `<img
      class="h-10 w-10 flex-shrink-0 sm:h-9 sm:w-9 lg:h-12 lg:w-12"
      src="${userDetails.profile_picture}" alt="">`;
      }
      if (!this._utilityService.hasValidProfilePicture(userDetails.profile_picture) && userDetails.first_name) {
        templateHtml += `<div 
        class="flex items-center justify-center overflow-hidden uppercase text-4xl font-secondary leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 h-10 w-10 flex-shrink-0 sm:h-9 sm:w-9 lg:h-12 lg:w-12">
        ${userDetails.first_name[0]}
    </div>`;
      }
      templateHtml += `</div>`;
      templateHtml += `<div class="m-2 sm:ml-3 sm:flex-1 break-all max-w-2/4">
      <div class="flex items-center">
          <h3 class="text-lg font-bold text-gray-600 sm:text-1xl truncate max-w-3/4">
              ${userDetails.first_name} ${userDetails.last_name ?? ''}</h3>
      </div>`;
      if (userDetails.designation) {
        templateHtml += `<div>`;
        templateHtml += `<span class="text-gray-500 text-base truncate">
        ${userDetails.designation}</span>`;
        if (this.fieldsVisibility?.role && userDetails?.role?.role_name) {
          templateHtml += `<span 
          class="text-gray-500 text-base truncate">
          (${userDetails?.role?.role_name})</span>`;
        }

        if (this.fieldsVisibility?.capacity && viewMode === 'DAY' && this.capacityHours) {
          templateHtml += `<br><span class="text-gray-500 text-base truncate">
          ${this.capacityHours?.hours ? this.capacityHours?.hours + 'h' : ''} ${this.capacityHours?.minutes ?
              this.capacityHours?.minutes + 'm' : ''} ${this.capacityHours?.hours || this.capacityHours?.minutes ? 'remaining - ' : ''}${this.getCapacityPercentage(workMins, availableMins) + '%'}</span>`;
        }
        templateHtml += `</div>`;
      }

      templateHtml += `</div>`;
      templateHtml += `<div class="flex ml-auto items-center">`;
      if (userDetails?.email) {
        templateHtml += `<a href="mailto:${userDetails?.email}" title="${this._utilityService.getLocaleValue('email')}"
        class="flex flex-shrink-0 hover:bg-gray-100 rounded-lg items-center justify-center h-8 w-8 cursor-pointer">
        <i class="ti ti-mail text-gray-800 text-xl"></i>
        </a>`;
      }
      if (userDetails?.mobile_phone_number || userDetails?.work_phone_number || userDetails?.home_phone_number) {
        templateHtml += `
        <a href="tel:${userDetails?.mobile_phone_number || userDetails?.work_phone_number || userDetails?.home_phone_number}"
            title="${this._utilityService.getLocaleValue('text.contact')}"
            class="flex flex-shrink-0 hover:bg-gray-100 rounded-lg items-center justify-center h-8 w-8 cursor-pointer">
            <i class="ti ti-phone text-gray-800 text-xl"></i>
        </a>`;
      }
      templateHtml += `<a target="_blank" id='employeeDetailsExternal' data-useruid="${userDetails.user_uid}" 
          title="${this._utilityService.getLocaleValue('employee.preview.view.details')}"
          class="flex flex-shrink-0 hover:bg-gray-100 rounded-lg items-center justify-center h-8 w-8 cursor-pointer">
          <i class="ti ti ti-id text-gray-800 text-xl"></i>
      </a>`;
      templateHtml += `</div>`;
      templateHtml += `</div>`;

      templateHtml += `<div>`;
      templateHtml += `<div class="flex pt-4 primary-font">
      <span class="w-1/3 text-base">${tab === 'jobs' ? this._utilityService.getLocaleValue('text.jobs') : this._utilityService.getLocaleValue('text.routes')}</span>
        <div class="flex items-center w-2/3">
            <em class="ti text-xl mr-1 ${tab === 'jobs' ? 'ti-briefcase': 'ti-route'}"></em>
            <div class="text-base">
                ${eventCount || 0}
            </div>
            </div>
        </div>`;
      if (this.fieldsVisibility?.timesheet_status && (this.timeSheetValue?.punchedIn || this.timeSheetValue?.punchedOut)) {
        templateHtml += `<div class="flex my-2.5 mx-5 primary-font"> <span class="w-1/3 text-base">${this._utilityService.getLocaleValue('text.timesheet')}</span>`;
        templateHtml += ` <div class="flex flex-col w-2/3">`;
        if (this.timeSheetValue?.punchedIn) {
          templateHtml += `<div class="flex mb-2">
          <em class="ti ti-clock-hour-9 text-xl mr-1"></em>
          <div class="text-base">
              ${this._utilityService.getLocaleValue('employee.preview.punched_in.label')} - <span>${this.dateTimePipe.transform(this.timeSheetValue.punchedIn)}</span>
          </div>
      </div>`;
        }
        if (this.timeSheetValue?.punchedOut) {
          templateHtml += `<div class="flex mb-2">
          <em class="ti ti-clock-hour-9 text-xl mr-1"></em>
          <div class="text-base">
              ${this._utilityService.getLocaleValue('employee.preview.punched_out.label')} - <span>${this.dateTimePipe.transform(this.timeSheetValue.punchedOut)}</span>
          </div>
      </div>`;
        }
        templateHtml += `</div>`;
        templateHtml += `</div>`;
      }
      if (this.fieldsVisibility?.skillset && userDetails.user_skills?.length) {
        templateHtml += `<div class="flex my-2.5 primary-font">`;
        templateHtml += `<span class="w-1/3 text-base">${this._utilityService.getLocaleValue('text.skills')}</span>`;
        templateHtml += ` <div class="flex items-center -mt-2 w-2/3">`;
        templateHtml += `<ul role="list" class="w-full divide-y divide-gray-200">`;
        userDetails.user_skills?.forEach((skill: any) => {
          templateHtml += `<li class="py-2 space-y-1.5 w-full text-base primary-font">`;
          templateHtml += `<p class="font-medium">
          ${skill.skillsets?.skillset_name ?? ''}
          </p>`;
          templateHtml += `<div class="w-2/4 rounded h-1.5 bg-gray-200">
          <div class="h-full rounded ${(skill.skill_level || 0) > 20 ? 'bg-blue-800' : ''} ${(skill.skill_level || 0) <= 20 ? 'bg-red-500' : ''}" style="width: ${(skill.skill_level || 0)}%"
              title="${(skill.skill_level || 0) + '%'}">
            </div>
          </div>`;
          if (skill.end_date && this.isExpired(skill.end_date)) {
            templateHtml += `<p class="text-base text-red-500">
            ${this._utilityService.getLocaleValue('expired')}
          </p>`;
          }
          if (skill.end_date && !this.isExpired(skill.end_date)) {
            templateHtml += `<p class="text-md text-gray-500">
            ${this._utilityService.getLocaleValue('text.expires_on')} ${this.dateFormatPipe.transform(skill.end_date)}
            </p>`;
          }
          templateHtml += `</li>`;
        });
        templateHtml += `</ul>`;
        templateHtml += `</div>`;
        templateHtml += `</div>`;
      }
      if (userDetails?.user_shifts?.length) {
        templateHtml += `
        <div class="flex pt-4 primary-font">
            <span class="w-1/3 text-base">${this._utilityService.getLocaleValue('text.shift_hours', 'Shift Hours')}</span>
            <div class="flex flex-col space-y-2 w-2/3 max-h-[9rem] overflow-y-auto zuper-scrollbar">
            ${userDetails.user_shifts.map((shift: any) => `
            <div class="flex items-start space-x-2">
              <em class="ti ti-calendar-clock text-xl mt-1"></em>
              <div class="flex flex-col items-start justify-center flex-wrap">
                <div class="text-base flex items-center space-x-1">
                    ${this._dispatchBoardService.getStartEndTime(shift?.start_date_time, shift?.end_date_time, true).map((date: string) => {
                      return `<span>${date}</span>`;
                    }).join('&nbsp-&nbsp')}
                </div>
                ${shift?.shift_label? `<span class="font-normal text-base text-gray-700">${shift?.shift_label}</span>`: ''}
              </div>
            </div>`).join('')}
            </div>
        </div>`;
      }
      if (this.fieldsVisibility?.work_hours && viewMode === 'DAY' && userDetails.work_hours?.length && this.getWorkHours()) {
        templateHtml += `
        <div class="flex pt-4 primary-font">
                <span class="w-1/3 text-base">${this._utilityService.getLocaleValue('text.work_hours')}</span>
                <div class="flex items-center w-2/3">
                    <em class="ti ti-clock text-xl mr-1"></em>
                    <div class="text-base">
                        ${this.getWorkHours()}
                    </div>
                </div>
            </div>`;
      }
      templateHtml += `</div>`;
      templateHtml += `</div>`;
      templateHtml += `</div>`;
    }
    return templateHtml;
  }

  getRouteEventHeaderTemplate(routeDetails: any): string {
    const routeName = routeDetails?.route_name || '';
    const routeColor = routeDetails?.color || '#ffffff';
    const isRouteLocked = routeDetails?.is_locked;
    let templateHtml = '';
    templateHtml = `<div class="flex justify-center items-center space-x-1 cursor-default text-black w-inherit">
        <div class="w-3.5 h-3.5 mt-0.5 ml-1 rounded-sm" style='background-color: ${routeColor}'></div>
        <div class="text-base font-medium truncate block" title="${routeName}">${routeName}</div>
        ${isRouteLocked ? `<i class='ti ti-lock text-xl font-normal pr-1' title='${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.locked')}'></i>` : ''}
      </div>`;
    return templateHtml;
  }

  getRouteTravelDistanceTooltipTemplate(travelTime: number, travelDistance: number, modeOfTransport: string = 'CAR'): string {
    const time: string = this._utilityService.convertSecondsToHours(travelTime);
    const distance: string = this._utilityService.getDistance(travelDistance);
    const distanceUnit: string = this._utilityService.companyConfig?.general?.distance_metric === 'MILES' ? this._utilityService.getLocaleValue('route.distance.metric.miles') : this._utilityService.getLocaleValue('route.distance.metric.kilo_meters');
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const templateHTML = `<div class="h-full w-full text-base font-normal space-y-1">
    <div class="flex items-center">
      <span class="font-medium">${this._utilityService.getLocaleValue('text.mode_of_transport', 'Mode of Transport')} : </span>
      <i class="ti text-xl mx-1 ${this.modeOfTransportIcon[modeOfTransport] || 'ti-car'}"></i>
      <span>${this.titlecasePipe.transform(modeOfTransport)}</span>
    </div>
    <div class="flex items-center">
      <span class="font-medium">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.tooltip.travel_distance', 'Travel Distance')} : </span>
      <span class='ml-1'>${distance} ${distanceUnit}</span>
    </div>
    <div class="flex items-center">
      <span class="font-medium">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.tooltip.travel_time', 'Travel Time')} : </span>
      <span class='ml-1'>${time}</span>
    </div>
  </div>`;
    return templateHTML;
  }

  getTableProxyView(viewObj: any): any {
    const MAX_COLUMN = 2;
    const viewObjChunks = _.chunk(viewObj, MAX_COLUMN);
    const proxyCardView = {};
    viewObjChunks?.forEach((rowData: any, index) => {
      proxyCardView[index + 1] = rowData;
    });

    return proxyCardView;
  }

  getCardColor(jobDetails: any, category: JobColorType): string {
    let colorCode: string = '';
    if (category === 'jobStatus') {
      colorCode = jobDetails?.current_job_status?.status_color ?? badgeColorCode[jobDetails?.current_job_status?.status_type];
    }
    else if (category === 'jobPriority') {
      const priority = jobDetails?.job_priority;
      colorCode = badgeColorCode[priority] || '#887ECB';
    }
    else if (category === 'jobCategory') {
      colorCode = jobDetails?.job_category?.category_color;
    }
    else if (category === 'team') {
      const assignedTo = jobDetails?.assigned_to;
      if (assignedTo?.length > 0) {
        colorCode = assignedTo[0]?.team?.team_color;
      }
    }
    else if (category === 'custom') {
      colorCode = jobDetails?.color_profile?.color || '#887ECB';
    }
    else if (category === 'none') {
      colorCode = '#ffffff';
    }
    return colorCode;
  }

  getGridColorTooltip(jobDetails: any, category: JobColorType): any {
    let tooltipValue: string = '';
    if (category === 'jobStatus') {
      tooltipValue = jobDetails?.current_job_status?.status_name;
    }
    else if (category === 'jobPriority') {
      tooltipValue = this.titlecasePipe.transform(jobDetails?.job_priority || '');
    }
    else if (category === 'jobCategory') {
      tooltipValue = jobDetails?.job_category?.category_name;
    }
    else if (category === 'team') {
      const assignedTo = jobDetails?.assigned_to;
      if (assignedTo?.length > 0) {
        tooltipValue = assignedTo[0]?.team?.team_name;
      }
    }

    return tooltipValue;
  }

  getRouteDetailsTooltipTemplate(routeDetails: any): string {
    const routeName = routeDetails?.route_name || '';
    const routeColor = routeDetails?.color || '#ffffff';
    const modeOfTransport = this.titlecasePipe.transform(routeDetails.transport_mode || 'CAR');
    const distanceUnit: string = this._utilityService.companyConfig?.general?.distance_metric === 'MILES' ? this._utilityService.getLocaleValue('route.distance.metric.miles') : this._utilityService.getLocaleValue('route.distance.metric.kilo_meters');
    const routeType = this.titlecasePipe.transform(routeDetails?.route_type || 'FASTEST');
    const duration = routeDetails?.duration || 1;
    const routeStartDateTime = moment.utc(routeDetails?.departure);
    const routeEndDateTime = routeStartDateTime.clone().add(duration, 'h');
    const routeStartEndTime = this._dispatchBoardService.getStartEndTime(routeStartDateTime, routeEndDateTime, false);
    const totalDistance = this._utilityService.getDistance(routeDetails?.total_distance || 0);
    const totalHour = this._utilityService.getHours(routeDetails?.total_time || 0);
    const totalMin = this._utilityService.getMin(routeDetails?.total_time || 0);
    const totalJobs = routeDetails?.total_jobs || 0;
    const assignedTo = routeDetails?.assigned_to;
    const isLocked = routeDetails?.is_locked;
    const formatedAssignedTo = this._dispatchBoardService.getAssignedNameAndCount(assignedTo);
    let templateHTML: string = '';
    templateHTML += `<div class='flex flex-col primary-font w-full h-full text-base font-normal text-gray-700 space-y-1'>`;
    templateHTML += `<div class='w-full flex space-x-1.5 items-center justify-center'><div><div class='w-3.5 h-3.5 rounded-sm' style='background-color: ${routeColor}'></div></div><span class='font-semibold' title='${this._utilityService.getLocaleValue('text.route_name', 'Route Name')} : ${routeName}'>${routeName}</span>${isLocked ? `<i class='ti ti-lock text-xl font-normal' title='${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.locked')}'></i>` : ''}</div>`;
    templateHTML += `<div class='w-full flex items-center space-x-2'> 
    <div class='flex items-center'> <i class="${modeOfTransport === 'Car' ? 'ti ti-car' : modeOfTransport === 'Truck' ? 'ti ti-truck' : 'ti ti-walk'} text-xl mx-1"></i><span title='${this._utilityService.getLocaleValue('text.mode_of_transport', 'Mode of Transport')} : ${modeOfTransport}'>${modeOfTransport}</span></div>
    <div class='flex items-center'> <i class="ti ti-route text-xl mx-1"></i><span title='${this._utilityService.getLocaleValue('text.route_type', 'Route Type')} : ${routeType}'>${routeType}</span></div>
    </div>`;
    templateHTML += totalHour || totalMin || totalDistance ? `<div class='w-full flex items-center space-x-2'>` : '';
    templateHTML += totalHour || totalMin ? `<div class='flex items-center'><i class='ti ti-clock text-xl mx-1'></i> <span title='${this._utilityService.getLocaleValue('label.total_time', 'Total Time')}'>${totalHour ? totalHour : ''} ${totalHour ? this._utilityService.getLocaleValue('route.hours') : ''} ${totalMin ? totalMin : ''} ${totalMin ? this._utilityService.getLocaleValue('route.min') : ''}</span></div>` : '';
    templateHTML += totalDistance ? `<div class='flex items-center'><i class='ti ti-timeline text-xl mx-1'></i> <span title='${this._utilityService.getLocaleValue('text.total_distance', 'Total Distance')}'>${totalDistance} ${distanceUnit}</span></div>` : '';
    templateHTML += totalHour || totalMin || totalDistance ? `</div>` : '';
    templateHTML += `<div class='w-full flex items-center space-x-2'> 
    ${formatedAssignedTo ? `    <div class='flex items-center'> <i class="ti ${assignedTo.length <= 1 && formatedAssignedTo ? 'ti-user' : 'ti-users'} text-xl mx-1"></i><span title='${this._utilityService.getLocaleValue('text.assigned_to', 'Assigned To')} : ${formatedAssignedTo}'>${formatedAssignedTo}</span></div>`: ''}
    <div class='flex items-center'> <i class="ti ti-briefcase text-xl mx-1"></i><span title='${this._utilityService.getLocaleValue('text.no_of_jobs', 'No of Jobs')} : ${totalJobs}'>${totalJobs} ${this._utilityService.getLocaleValue('text.jobs', 'Jobs')}</span></div>
    </div>`;
    templateHTML += `<div class='w-full flex items-center'> 
    <div class='flex items-center'><i class='ti ti-calendar-time text-xl mx-1'></i> <span>${routeStartEndTime[0]}</span><i class='ti ti-arrow-narrow-right text-xl mx-1'></i><span>${routeStartEndTime[1]}</span></div>
    </div>`;
    templateHTML += `</div>`;
    return templateHTML;
  }

  //Move route component - Scheduler's user column (route) template
  getMoveJobSchedulerRouteTemplate(routeDetails: any, timezone: string = this._utilityService.timeZone): string {
    const routeName = routeDetails?.route_name || '';
    const maxAssigedToprofile: number = 3;
    const totalJobs = routeDetails?.total_jobs || 0;
    const isLocked = routeDetails?.is_locked;
    const routeColor = routeDetails?.color || '#60a5fa';
    const isRecurrance = routeDetails?.is_recurrence;
    const routeStartDateTime = moment(routeDetails?.departure).tz(timezone).format(this._utilityService.dateTimeFormat);
    const utilisedPercentage = routeDetails?.jobs?.length ? this.recurringRouteService.getRouteUtilisedPercentage(routeDetails?.duration, routeDetails?.total_time): 0;
    const routeHoursRemaining = this.recurringRouteService.getRouteHoursRemaining(routeDetails?.duration, routeDetails?.jobs?.length ? routeDetails?.total_time : 0);
    const templateHTML = `
    <div class="flex flex-col space-y-1.5 primary-font text-base font-normal text-gray-700 w-inherit">
    <div class="flex items-center justify-between">
      <div class='flex items-center space-x-1.5 truncate'>
        ${isRecurrance? `<i class="ti ti-repeat text-light-blue text-2xl"></i>`: ''}
        ${isLocked? `<i class="ti ti-lock text-red-500 text-2xl"></i>`: ''}
        <div class='w-3.5 h-3.5 rounded-sm min-w-fit' style="background: ${routeColor}"></div>
        <span class="block truncate" title="${routeName}">${routeName}</span>
      </div>
      ${this.getAssignedToAvatarView(routeDetails?.assigned_to || [], maxAssigedToprofile)}
    </div>
    <div class="flex items-center justify-between space-x-1.5 truncate">
      <span class="text-gray-500 text-base">${routeStartDateTime}</span>
      <span class="text-gray-500 text-base">${totalJobs} ${totalJobs > 1 ? this._utilityService.getLocaleValue('text.jobs', 'Jobs'): this._utilityService.getLocaleValue('job', 'Job')}</span>
    </div>
    <div class="mt-1">
      <div class="flex justify-between mb-1">
        <span class="text-base font-medium text-gray-700 dark:text-white">${utilisedPercentage || 0}% ${this._utilityService.getLocaleValue('text.utilised')} </span>
        <span class="text-base font-normal text-gray-500 dark:text-white">${routeHoursRemaining || '0h'} ${this._utilityService.getLocaleValue('text.remaining')}</span>
      </div>
      <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
        <div class="bg-blue-600 h-2.5 rounded-full" style="width: ${utilisedPercentage}%"></div>
      </div>
    </div>
  </div>`;
    return templateHTML;
  }

  getMoveJobSchedulerRouteTooltipTemplate(routeDetails: any, timezone: string = this._utilityService.timeZone): string {
    const routeName = routeDetails?.route_name || '';
    const totalJobs = routeDetails?.total_jobs || 0;
    const isLocked = routeDetails?.is_locked;
    const routeColor = routeDetails?.color || '#60a5fa';
    const isRecurrance = routeDetails?.is_recurrence;
    const assignedTo = routeDetails?.assigned_to;
    const rrText: string = isRecurrance ? this.recurringRouteService.getRruleText(routeDetails?.recurring_route?.rrule): '';
    const startLocation = this.getCityAddress(routeDetails?.start_location);
    const endLocation = this.getCityAddress(routeDetails?.end_location);
    const routeStartDateTime = moment(routeDetails?.departure);
    const routeDuration = routeDetails?.duration || 1;
    const routeEndDateTime = routeStartDateTime.clone().add(routeDuration, 'h');
    const routeStartEndTime = this._dispatchBoardService.getStartEndTime(routeStartDateTime, routeEndDateTime, false);
    let templateHTML = `
    <div class="flex flex-col space-y-2 primary-font text-base text-gray-700 font-normal w-full">
      <div class="flex items-center space-x-1.5">
        ${isRecurrance? `<i class="ti ti-repeat text-light-blue text-2xl"></i>`: ''}
        ${isLocked? `<i class="ti ti-lock text-red-500 text-2xl"></i>`: ''}
        <div class='w-3.5 h-3.5 rounded-sm min-w-fit' style="background: ${routeColor}"></div>
        <span class="font-medium">${routeName}</span>
      </div>
      ${isRecurrance ? `<span class="text-gray-500">${this._utilityService.getLocaleValue('text.repeats')} ${rrText}</span>` : ''}`;
    templateHTML += `<div class='w-full flex items-center primary-font text-base text-gray-700 font-normal'> 
      <div class='flex items-center'> <span>${routeStartEndTime[0]}</span><i class='ti ti-arrow-narrow-right text-xl mx-1'></i><span>${routeStartEndTime[1]}</span></div>
    </div>`;
    if (assignedTo?.length) {
      templateHTML += `<div class="flex justify-items-start space-x-1">
        <span class="font-medium">${this._utilityService.getLocaleValue('text.assigned_to', 'Assigned To')} : </span>
        <div class=" flex-col flex max-h-20 overflow-auto min-w-44 zuper-scrollbar">`;
      assignedTo.forEach((assignedUser: any) => {
        templateHTML += `<span>${assignedUser?.user?.first_name || ''} ${assignedUser?.user?.last_name || ''}</span>`;
      });
      templateHTML += `</div> </div>`;
    }
    templateHTML += `<div class="flex justify-items-start space-x-1">
        <span class="font-medium min-w-fit">${this._utilityService.getLocaleValue('text.start_location')} : </span>
        <div class="max-h-20 overflow-auto zuper-scrollbar" >
          <span>${startLocation}</span>
        </div>
      </div>
      ${endLocation? `<div class="flex justify-items-start space-x-1">
        <span class="font-medium min-w-fit">${this._utilityService.getLocaleValue('text.end_location')} : </span>
        <div class="max-h-20 overflow-auto zuper-scrollbar" >
          <span>${endLocation}</span>
        </div>
      </div>`: ''}
    </div>
`;
return templateHTML;
  }

  getAssignedToAvatarView(assignedTo: any[], maxAssigedToprofile: number = 4): any {
    let templateHTML = `<div class="flex items-center min-w-max cursor-pointer ml-1">`;
    assignedTo.slice(0, maxAssigedToprofile).forEach((assignedUser: any, i: number) => {
      templateHTML += `<div class="relative" style="margin-left: ${i === 0 ? 0 : -7+i}px; z-index: ${maxAssigedToprofile - i}">`;
      if (this._utilityService.hasValidProfilePicture(assignedUser?.user?.profile_picture)) {
        templateHTML += `<img
        class="h-6 w-6 relative rounded-full ring-2 ring-white" loading="lazy"
        src="${assignedUser?.user?.profile_picture}" alt=""
        title="${assignedUser?.user?.first_name || ''} ${assignedUser?.user?.last_name || ''}">`;
      }
      else {
        templateHTML += `
        <div title="${assignedUser?.user?.first_name || ''} ${assignedUser?.user?.last_name || ''}"
        class="flex items-center justify-center h-6 w-6 ring-2 ring-white rounded-full uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200">
        ${(assignedUser?.user?.first_name || '').slice(0,1)} </div>`;
      }
      templateHTML += `</div>`;
    });
    if (assignedTo?.length > maxAssigedToprofile) {
      const otherUsers: string = assignedTo.slice(maxAssigedToprofile).map((userDetails: any) => userDetails?.user?.first_name || '' + ' ' + userDetails?.user?.last_name || '' ).join(',');
      templateHTML += `
      <div
        class="flex items-center justify-center h-6 w-6 ring-2 ml-1 text-sm ring-white rounded-full uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200" title="${otherUsers}">
        +${assignedTo?.length - maxAssigedToprofile}</div>`;
    }
    templateHTML += `</div>`;
    return templateHTML;
  }

  getRoutePolylineTooltipTemplate(routeDetails: any, selectedJobCount: number, timezone: string = this._utilityService.timeZone): string {
    const routeName = routeDetails?.route_name || '';
    const maxAssigedToprofile: number = 3;
    const totalJobs = routeDetails?.total_jobs || 0;
    const isLocked = routeDetails?.is_locked;
    const routeColor = routeDetails?.color || '#60a5fa';
    const isRecurrance = routeDetails?.is_recurrence;
    const duration = routeDetails?.duration || 1;
    const routeStartDateTime = moment(routeDetails?.departure).tz(timezone).format(this._utilityService.dateTimeFormat);
    const utilisedPercentage = routeDetails?.jobs?.length ? this.recurringRouteService.getRouteUtilisedPercentage(routeDetails?.duration, routeDetails?.total_time): 0;
    const routeHoursRemaining = this.recurringRouteService.getRouteHoursRemaining(routeDetails?.duration, routeDetails?.jobs?.length ? routeDetails?.total_time : 0);
    const templateHTML = `
    <div class="flex flex-col space-y-1.5 primary-font text-base font-normal text-gray-700 w-inherit p-2 pt-2.5">
      <div class="flex items-center justify-between">
        <div class='flex items-center space-x-1.5 truncate'>
          ${isRecurrance ? `<i class="ti ti-repeat text-light-blue text-2xl"></i>` : ''}
          ${isLocked ? `<i class="ti ti-lock text-red-500 text-2xl"></i>` : ''}
          <div class='w-3.5 h-3.5 rounded-sm min-w-fit' style="background: ${routeColor}"></div>  
          <span class="block truncate" title="${routeName}">${routeName}</span>
        </div>
        ${this.getAssignedToAvatarView(routeDetails?.assigned_to || [], maxAssigedToprofile)}
      </div>
      <div class="flex items-center justify-between space-x-1.5 truncate">
        <span class="text-gray-500 text-base">${routeStartDateTime} (${duration} ${duration <= 1 ? 'hr' : 'hrs'})</span>
        <span class="text-gray-500 text-base">${totalJobs} ${totalJobs > 1 ? this._utilityService.getLocaleValue('text.jobs', 'Jobs') : this._utilityService.getLocaleValue('job', 'Job')}</span>
      </div>
      <div class="flex justify-between text-base font-normal">
          <span class="text-gray-700 dark:text-white">${utilisedPercentage || 0}% ${this._utilityService.getLocaleValue('text.utilised')} </span>
          <span class="text-gray-500 dark:text-white">${routeHoursRemaining || '0h'} ${this._utilityService.getLocaleValue('text.remaining')}</span>
      </div>
      ${selectedJobCount ? `<div class="flex justify-center text-center primary-font text-base text-gray-700">
        <button type="button" id="add-job-to-route-btn" class="px-4 items-center py-1.5 border border-gray-300 shadow-sm rounded-md text-gray-700 font-normal bg-white hover:bg-gray-50 focus:outline-none"> Add ${selectedJobCount} Job(s) to Route </button>
      </div>`: ''}
  </div>`;
    return templateHTML;
  }

  counter(i: number): any[] {
    return Array(i).fill(1).map((x, value) => value + 1);
  }

  getTableDefaultFieldColumn(tab: 'jobs' | 'routes', key: any, column: any): any {
    let rendererHTML: string;
    switch (key) {
      case 'work_order_skillsets': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value?.skill_name) {
            rendererHTML = `
            <div class="flex gap-1">
            <span class="bg-blue-100 text-blue-700 text-base font-normal block truncate min-w-8 mr-2 px-2 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300" title="${value?.skill_name}">${value?.skill_name}</span>
            `;
            if (value?.skill_count > 0) {
              rendererHTML += `<span class="bg-blue-100 text-blue-700 text-base font-normal block truncate min-w-8 mr-2 px-2 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300" title=" ${value?.skill_count} more">+ ${value?.skill_count} more</span>
            </div>`;
            }
            else {
              rendererHTML += `</div>`;
            }
          }
          return rendererHTML;
        };
      }

      case 'current_work_order_status': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value) {
            rendererHTML = `
            <span class="text-white text-base font-normal block truncate min-w-8 mr-2 px-2 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300" style="background-color: ${record?.record.data.status_color_selector}" title="${value}">${value}</span>
            `;
          }
          return rendererHTML;
        };
      }

      case 'work_order_priority': {
        return (record: any): any => {
          let value = record.record?.data[column.key];
          const priorityColor = badgeColorCode[value] || '#ffffff';
          rendererHTML = '-';
          if (value) {
            value = this.titlecasePipe.transform(value);
            rendererHTML = `
            <div class ='flex items-center gap-1 border border-gray-300 rounded-2xl py-1 px-2' title='${value}'><div class='w-3 h-3 rounded' style='background-color:${priorityColor};'></div>
            <span class='block truncate text-base font-normal'>${value}</span></div>
            `;
          }
          return rendererHTML;
        };
      }

      case 'work_order_assigned_to': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value?.count !== -1) {
            rendererHTML = `<div class="block truncate font-normal text-base mr-2">${value?.name}</div>`;
            if (value?.count > 0) {
              rendererHTML += `
              <div class="block truncate font-normal text-base">
                      +${value?.count} ${this._utilityService.getLocaleValue('text.more', 'more')}
              </div>`;
            }
          }
          return rendererHTML;
        };
      }

      case 'work_order_title': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '';
          if (value) {
            if (record?.record.data?.routeDetails?.isRouteJob) {
              const routeName = record?.record.data?.routeDetails?.routeName;
              rendererHTML += `<em title="${this._utilityService.getLocaleValue('dispatchBoard.template.grid.route_job', 'Assigned to Route')}: ${routeName}" class="ti ti-road text-2xl text-blue-700 mr-2"></em>`;
            }
            if (!record?.record.data?.isJobHasGeoCords) {
              rendererHTML += `<em title="${this._utilityService.getLocaleValue('dataPicker.job.geo_coordinates.alert_text', 'Geo Co-ordinates not found for this job')}" class="ti ti-map-pin-off text-xl text-red-700 mr-2"></em>`;
            }
            if (record?.record.data.is_recurrence) {
              rendererHTML += `<em title="${this._utilityService.getLocaleValue('text.recurrent_job', 'Recurrent Job')}" class="ti ti-repeat text-2xl text-blue-700 mr-2"></em>`;
            }
            if (record?.record.data.delayed_job) {
              rendererHTML += `<em title="${this._utilityService.getLocaleValue('text.delay_job', 'Delay Job')}" class="ti ti-alarm text-2xl text-red-700 mr-2"></em>`;
            }
            rendererHTML += `<span class='block truncate font-normal text-base' title="${value}">${value}</span>`;
          }
          else {
            rendererHTML = '-';
          }
          return rendererHTML;
        };
      }

      case 'work_order_actual_date':
      case 'work_order_scheduled_date': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value) {
            const formatedStartDateTime = `${value.startDateTime} ${value.endDateTime ? `-> ${value.endDateTime}` : ``}`;
            rendererHTML = `<div class="flex gap-2 text-base font-normal text-gray-700 overflow-hidden whitespace-nowrap text-ellipsis" title="${formatedStartDateTime}"><span
            class="block truncate font-normal text-base">${value.startDateTime} ${value.endDateTime ? `<i class='ti ti-arrow-narrow-right text-xl mx-1'></i> ${value.endDateTime}` : ``}</div>`;
          }
          return rendererHTML;
        };
      }

      case 'total_jobs': {
        return (record: any): any => {
          const value = record.record?.data[column.key] ?? '-';
          rendererHTML = `<div class="block truncate font-normal text-base mr-2" title="${value}">${value}</div>`;
          return rendererHTML;
        };
      }
      case 'job_tags': {
        return (record: any): any => {
          const tags = record.record?.data[column.key] || [];
          if (tags?.length) {
            let extraTagCount: number = 0;
            const tagsFormatted = tags?.join(', ');
            if (tags?.length > 1) {
              extraTagCount = tags?.length - 1;
            }
            rendererHTML = `<div class='p-1.5 w-fit truncate block text-base rounded bg-gray-200 text-gay-700' title="${tagsFormatted}">${tags[0]} ${extraTagCount ? `+ ${extraTagCount} ${this._utilityService.getLocaleValue('text.more')}`: ''}</div>`;
          }
          else {
            rendererHTML = `<div class="block truncate font-normal text-base mr-2">-</div>`;
          }
          return rendererHTML;
        };
      }
      case 'route_name': {
        return (record: any): any => {
          const value = record.record?.data[column.key] ?? '-';
          rendererHTML = '';
          if (record?.record.data?.routeDetails?.isLocked) {
            rendererHTML += `<em title="${this._utilityService.getLocaleValue('route.locked', 'Locked')}" class="ti ti-lock text-2xl text-red-700 mr-1"></em>`;
          }
          rendererHTML += `<div class="block truncate font-normal text-base mr-2" title="${value}">${value}</div>`;
          return rendererHTML;
        };
      }

      default: {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value) {
            rendererHTML = `<span class='text-base font-normal block truncate' title="${value}">${value}</span>`;
          }
          return rendererHTML;
        };
      }
    }
  }

  getTableCustomFieldColumn(type: any, column: any): any {
    let rendererHTML: string;
    switch (type) {
      case 'SINGLE_LINE':
      case 'TEXT':
        {
          return (record: any): any => {
            const value = record.record?.data[column.key];
            rendererHTML = '-';
            if (value?.href) {
              rendererHTML = `
            <a class="flex w-10/12 text-justify text-primary-500 hover:underline font-normal text-base" 
                href="${value?.href}" target="_blank" onclick="event.stopPropagation()">${this._utilityService.getLocaleValue('text.open_link')}</a>`;
            }
            else {
              rendererHTML = `<span>${value ? value : '-'}</span>`;
            }
            return rendererHTML;
          };
        }

      case 'FILE': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value?.href?.length > 1) {
            rendererHTML = `
            <span >
              <a class="flex w-10/12 text-justify text-primary-500 hover:underline font-normal text-base" 
                          href="${value?.href}" target="_blank" onclick="event.stopPropagation()">${this._utilityService.getLocaleValue('text.open_link')}</a>
            </span>`;
          }
          return rendererHTML;
        };
      }

      case 'LOOKUP': {
        return (record: any): any => {
          const value = record?.record.data[column.key];
          rendererHTML = '-';
          if (value?.href) {
            rendererHTML = `
            <span>
            <a class="flex w-10/12 text-justify text-primary-500 hover:underline font-normal text-base" 
            href="${value?.href}" target="_blank" onclick="event.stopPropagation()">${value?.value}</a>
            </span>`;
          }
          return rendererHTML;
        };
      }

      default: {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value) {
            rendererHTML = `<span class='block truncate w-fit font-normal text-base'>${value}</span>`;
          }
          return rendererHTML;
        };
      }

    }
  }

  //New Route grid card template
  getRouteCardRenderer(routeDetails: any, selectors: any[], columnSize: number = 2): string {
    //Default values
    const routePrimaryColor = routeDetails?.color || '#D21C1C';
    const routeSecondaryColor = this._utilityService.convertHexToRgba(routePrimaryColor, '0.35') || '#FF5656';
    const routeName = routeDetails?.route_name || '';
    const distanceUnit: string = this._utilityService.companyConfig?.general?.distance_metric === 'MILES' ? 'Mi' : 'Km';
    const routeDuration = routeDetails?.duration || 1;
    const routeStartDateTime = moment(routeDetails?.departure);
    const totalDistance = this._utilityService.getDistance(routeDetails?.total_distance || 0) || 0;
    const totalHour = this._utilityService.getHours(routeDetails?.total_time || 0) || 0;
    const totalMin = this._utilityService.getMin(routeDetails?.total_time || 0) || 0;
    const totalJobs = routeDetails?.total_jobs || 0;
    const assignedTo = routeDetails?.assigned_to || [];
    const isLocked = routeDetails?.is_locked;
    const isRecurrence = routeDetails?.is_recurrence;
    const startLocation = this.getCityAddress(routeDetails?.start_location);
    const endLocation = this.getCityAddress(routeDetails?.end_location);
    selectors = this.sanitizeGridRoutecardSelector(selectors);
    const maxAssigedToprofile = 4;

    let templateHTML: string = '';
    templateHTML += `<div class="w-full h-full min-w-72 font-normal primary-font text-base text-gray-700 dispatchTemplate space-y-2 m-auto bg-white border border-gray-200 cursor-pointer rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
    <div class="w-full flex items-center p-2">
    <div class="w-full h-auto flex items-center gap-2 truncate">
      <div class="w-fit">
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3041_114284)">
              <rect width="46" height="46" rx="6" fill="#E8F4FD"></rect>
              <rect x="14.5" y="-0.5" width="17" height="47" fill="white"></rect>
              <rect x="14.5" y="-0.5" width="17" height="47" stroke="#C2DCEF"></rect>
              <rect x="17" width="12" height="33" fill="${routeSecondaryColor}"></rect>
              <rect x="11" y="19" width="24" height="24" rx="12" fill="white"></rect>
              <path
                d="M18.17 37L23 34.81L27.83 37L28.28 36.55L23 23.8L17.72 36.55L18.17 37ZM23 43C21.34 43 19.78 42.685 18.32 42.055C16.86 41.425 15.59 40.57 14.51 39.49C13.43 38.41 12.575 37.14 11.945 35.68C11.315 34.22 11 32.66 11 31C11 29.34 11.315 27.78 11.945 26.32C12.575 24.86 13.43 23.59 14.51 22.51C15.59 21.43 16.86 20.575 18.32 19.945C19.78 19.315 21.34 19 23 19C24.66 19 26.22 19.315 27.68 19.945C29.14 20.575 30.41 21.43 31.49 22.51C32.57 23.59 33.425 24.86 34.055 26.32C34.685 27.78 35 29.34 35 31C35 32.66 34.685 34.22 34.055 35.68C33.425 37.14 32.57 38.41 31.49 39.49C30.41 40.57 29.14 41.425 27.68 42.055C26.22 42.685 24.66 43 23 43Z"
                fill="${routePrimaryColor}" ></path>
            </g>
            <defs>
              <clipPath id="clip0_3041_114284">
                <rect width="46" height="46" rx="6" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>
      </div>
      <div class="truncate w-full">
        <div class="primary-font font-semibold flex items-center" >
        ${isLocked ? `<i class='ti ti-lock text-xl font-medium mr-1.5 text-red-600 min-w-fit' title='${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.locked')}'></i>` : ''}
        ${isRecurrence ? `<i class='ti ti-repeat text-xl font-medium mr-1.5 text-blue-700 min-w-fit' title='${this._utilityService.getLocaleValue('text.recurring_route', 'Recurring Route')}'></i>` : ''}
        <span title="${routeName}" class='block truncate'>${routeName}</span>
        </div>
        <div class="flex items-center justify-between">
          <div class="w-full flex items-center space-x-1 mt-1">
            ${totalHour || totalMin ? `<span title='${this._utilityService.getLocaleValue('label.total_time', 'Total Time')}' class="truncate">${totalHour ? totalHour : ''} ${totalHour ? this._utilityService.getLocaleValue('route.hours') : ''} ${totalMin ? totalMin : ''} ${totalMin ? this._utilityService.getLocaleValue('route.min') : ''}</span>` : ''}
            ${totalHour || totalMin ? `${totalDistance ? `<span class="truncate" title='${this._utilityService.getLocaleValue('text.total_distance', 'Total Distance')}: (${totalDistance} ${distanceUnit})'>(${totalDistance} ${distanceUnit})</span>` : ''}` : ''}
            ${!totalHour && !totalMin ? `${totalDistance ? `<span class="truncate" title='${this._utilityService.getLocaleValue('text.total_distance', 'Total Distance')}: ${totalDistance} ${distanceUnit}'>${totalDistance} ${distanceUnit}</span>` : ''}` : ''}
            </div>
            <div class="block text-base text-gray-600 mt-1" title="${this._utilityService.getLocaleValue('route.label.duration')}">${routeDuration} ${routeDuration <= 1 ? 'hr' : 'hrs'}</div>
          </div>
      </div>
    </div>
    </div>`;

    if (selectors.includes('start_end_location') && (startLocation || endLocation)) {
      templateHTML += `<div class="w-full flex items-center px-2 pb-1.5">
      <div class="grid-col text-center">
        ${startLocation ? `<i class="ti ti-home text-lg bg-blue-200 p-1 font-medium rounded-full" style="color: #0277BD;"></i>` : ''}
        ${endLocation ? `<div class="row-span-1 h-3 my-0.5 text-center align-middle ml-2.5 w-0.5" style="background-color: #0277BD;"></div>
        <i class="ti ti-flag text-lg bg-blue-200 p-1 font-medium rounded-full" style="color: #0277BD;"></i>`: ''}
      </div>
      <div class="ml-2 w-full truncate">
         ${startLocation ? `<div class="truncate text-base primary-font font-normal ${endLocation ? 'mb-3' : ''}" title="Start location: ${startLocation} ">${startLocation}</div>` : ''}
         ${endLocation ? `<div class=" truncate text-base primary-font font-normal" title="End location: ${endLocation}">${endLocation} </div>` : ''}
      </div>
    </div>`;
      selectors = _.without(selectors, 'start_end_location');
    }
    selectors = _.chunk(selectors, columnSize);
    //Dynamic content
    selectors.forEach((selectorChunk: any[]) => {
      templateHTML += `<div class="flex w-full gap-1.5 px-2">`;
      selectorChunk.forEach((selector: any, index: number) => {
        const [selectorTemplate, hasValue] = this.routeGridCardValueRenderer(routeDetails, selector);
        if (hasValue) {
          templateHTML += `<div class="truncate max-w-1/2 ${index % 2 ? 'flex-1' : 'flex-0 mr-2'}">`;
          templateHTML += selectorTemplate;
          templateHTML += '</div>';
        }
      });
      templateHTML += '</div>';
    });

    templateHTML += `
    <div class="p-2 rounded-b-lg bg-gray-100 pb-4 primary-font ${assignedTo?.length ? 'py-1.5' : ''}">
      <div class='flex justify-between items-center'>`;
    templateHTML += `<div class='flex items-center'>`;

    if (assignedTo?.length) {
      templateHTML += `<div class='flex items-center assigned-to ${isLocked? 'cursor-default': ''}' id="assign-user-btn" title="${isLocked? `${this._utilityService.getLocaleValue('recurring_route.unlock_alert')}`: ''}">`;
      assignedTo?.slice(0, maxAssigedToprofile).forEach((assignee: any, index: number) => {
        const profilePicture = assignee?.user?.profile_picture;
        const userName = this._utilityService.concatTwoStrings(assignee?.user?.first_name, assignee?.user?.last_name) || assignee?.team?.team_name || '';
        if (profilePicture && userName && this._utilityService.hasValidProfilePicture(profilePicture)) {
          templateHTML += `<img class="h-6 w-6 relative rounded-full ring-2 ring-white" loading="lazy" src="${profilePicture}" alt="${userName}" title="${userName}" style="left: -${index * 5}px; z-index: ${maxAssigedToprofile - index};">`;
        }
        if (userName && !this._utilityService.hasValidProfilePicture(profilePicture)) {
          templateHTML += `<div title="${userName}" class="flex relative items-center justify-center h-6 w-6 rounded-full overflow-hidden" style="left: -${index * 5}px; z-index: ${maxAssigedToprofile - index};">
          <div class="flex items-center justify-center h-6 w-6 ring-2 ring-white rounded-full uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200 ng-star-inserted"> ${userName.slice(0, 1)}</div>
        </div>`;
        }
      });
      if (assignedTo?.length > maxAssigedToprofile) {
        templateHTML += `<span class='primary-font relative text-base text-gray-500 ml-2' style="left: -${maxAssigedToprofile * 4}px"> + ${assignedTo?.length - maxAssigedToprofile} ${this._utilityService.getLocaleValue('text.more', 'More')}</span>`;
      }
      templateHTML += `</div>`;
      templateHTML += `</div>`;
    }
    else {
      templateHTML += `<div class='flex items-center gap-1 font-medium text-base primary-font ${isLocked? 'cursor-default': ''}' id="assign-user-btn" title="${isLocked? `${this._utilityService.getLocaleValue('recurring_route.unlock_alert')}`: ''}" style="color: #0277BD;"><i class='ti ti-user-plus text-2xl'></i><span>${this._utilityService.getLocaleValue('assign.employee.title')}</span></div>`;
      templateHTML += `</div>`;
    }
    templateHTML += `<span class='text-base text-gray-500 primary-font font-normal'>${totalJobs} ${totalJobs <= 1 ? this._utilityService.getLocaleValue('text.job', 'Job') : this._utilityService.getLocaleValue('text.jobs', 'Jobs')}</span>
      </div>
    </div>
  </div>`;
    return templateHTML;
  }

  //Templates
  getMoveRouteStartLocationPopupContent(routeDetails: any, isSourceRoute: boolean, isDestinationRoute: boolean, timezone: any = this._utilityService.timeZone): string {
    const routeName = routeDetails?.route_name || '';
    const routePrimaryColor = routeDetails?.color || '#D21C1C';
    const startLocation = this.getCityAddress(routeDetails?.start_location);
    const isLocked = routeDetails?.is_locked;
    const assignedTo = routeDetails?.assigned_to || [];
    const maxAssigedToprofile = 4;
    const isRecurringRoute: boolean = routeDetails?.is_recurrence;
    let rrText: string = null;
    if (isRecurringRoute) {
      const rrule: string = routeDetails?.recurring_route?.rrule;
      try {
        rrText = RRule?.fromString(rrule).toText();
      }
      catch {
        rrText = null;
      }
    }
    const routeStartDateTime = moment(routeDetails?.departure).tz(timezone).format(this._utilityService.dateTimeFormat);
    let templateHTML = `<div class="flex flex-col space-y-2">
      ${isDestinationRoute ? `<div class="flex items-center justify-center border-b p-2 primary-font text-base text-gray-700 font-normal cursor-pointer">
        <div class='font-bold text-base'>${this._utilityService.getLocaleValue('recurring_route.destination_route')}</div>
      </div>`: ''}
      ${isSourceRoute ? `<div class="flex items-center justify-center border-b p-2 primary-font text-base text-gray-700 font-normal cursor-pointer">
        <div class='font-bold text-base'>${this._utilityService.getLocaleValue('recurring_route.source_route')}</div>
      </div>`: ''}
      <div class='space-y-2 px-2 pb-2 ${!isDestinationRoute && !isSourceRoute? 'pt-2': ''}'>
      <div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal space-y-2">
        <i class="ti ti-route mt-1.5 text-2xl"></i>
        <div class="w-3.5 h-3.5 rounded mb-1" style='background: ${routePrimaryColor}'></div>
        ${isLocked ? `<i class="ti ti-lock text-red-600 text-2xl"></i>` : ''}
        <span class='font-semibold'>${routeName}</span>
      </div>
        ${isRecurringRoute && rrText? `<div class='flex items-center space-x-2'>
        <div class="min-w-fit">
          <i class="ti ti-repeat text-2xl text-light-blue"></i>
        </div>
        <div class="flex items-center space-x-1 text-base primary-font font-medium text-gray-700">
            <span>${this._utilityService.getLocaleValue('text.repeats', 'Repeats')}
            <span class="font-semibold">${rrText}</span>
            </span>
        </div>
          </div>`: ''}
        <div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal">
          <i class="ti ti-map-pin text-2xl"></i>
        <span><span class="font-semibold">${this._utilityService.getLocaleValue('text.start_location')}</span>: ${startLocation}</span>
        </div>
        <div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal">
          <i class="ti ti-clock text-2xl"></i>
        <span><span class="font-semibold">${this._utilityService.getLocaleValue('text.start_time')}</span>: ${routeStartDateTime}</span>
        </div>
        ${!isDestinationRoute && !isSourceRoute ? `<div class="flex items-center justify-center primary-font text-base text-gray-700 font-normal cursor-pointer" >
          <button id='set-as-destination-btn' class='px-6 py-2 font-medium hover:bg-gray-100 rounded-lg border'>${this._utilityService.getLocaleValue('recurring_route.move.set_as_destination_route')}</button>
        </div>`: ``}
        </div>
    </div>`;
    if (assignedTo?.length) {
      templateHTML += `<div class='flex items-center bg-gray-100 p-2 rounded-b-lg mt-2'>`;
      assignedTo?.slice(0, maxAssigedToprofile).forEach((assignee: any, index: number) => {
        const profilePicture = assignee?.user?.profile_picture;
        const userName = this._utilityService.concatTwoStrings(assignee?.user?.first_name, assignee?.user?.last_name) || assignee?.team?.team_name || '';
        if (profilePicture && userName && this._utilityService.hasValidProfilePicture(profilePicture)) {
          templateHTML += `<img class="h-6 w-6 relative rounded-full ring-2 ring-white" loading="lazy" src="${profilePicture}" alt="${userName}" title="${userName}" style="left: -${index * 5}px; z-index: ${maxAssigedToprofile - index};">`;
        }
        if (userName && !this._utilityService.hasValidProfilePicture(profilePicture)) {
          templateHTML += `<div title="${userName}" class="flex relative items-center justify-center h-6 w-6 rounded-full overflow-hidden" style="left: -${index * 5}px; z-index: ${maxAssigedToprofile - index};">
          <div class="flex items-center justify-center h-6 w-6 ring-2 ring-white rounded-full uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200 ng-star-inserted"> ${userName.slice(0, 1)}</div>
        </div>`;
        }
      });
      if (assignedTo?.length > maxAssigedToprofile) {
        templateHTML += `<span class='primary-font p-1 bg-white flex items-center justify-center relative text-sm h-6 w-6 rounded-full text-gray-700 ml-2' style="left: -${maxAssigedToprofile * 4}px"> +${assignedTo?.length - maxAssigedToprofile}</span>`;
      }
      templateHTML += `</div>`;
    }
    return templateHTML;
  }

  getMoveRouteEndLocationPopupContent(routeDetails: any, isSourceRoute?: boolean, isDestinationRoute?: boolean, timezone: any = this._utilityService.timeZone): string {
    const routeName = routeDetails?.route_name || '';
    const routePrimaryColor = routeDetails?.color || '#D21C1C';
    const endLocation = this.getCityAddress(routeDetails?.end_location);
    const isLocked = routeDetails?.is_locked;
    const routeDuration = routeDetails?.duration || 1;
    const routeStartDateTime = moment(routeDetails?.departure);
    const routeEndDateTime = routeStartDateTime.clone().add(routeDuration, 'h').tz(timezone).format(this._utilityService.dateTimeFormat);
    const templateHTML = `<div class="flex flex-col space-y-2">
    ${isDestinationRoute ? `<div class="flex items-center border-b justify-center p-2 primary-font text-base text-gray-700 font-normal cursor-pointer">
      <div class='font-bold text-base'>${this._utilityService.getLocaleValue('recurring_route.destination_route')}</div>
    </div>`: ''}
    ${isSourceRoute ? `<div class="flex items-center border-b justify-center p-2 primary-font text-base text-gray-700 font-normal cursor-pointer">
      <div class='font-bold text-base'>${this._utilityService.getLocaleValue('recurring_route.source_route')}</div>
    </div>`: ''}
      <div class='space-y-2 px-2 pb-2 ${!isDestinationRoute && !isSourceRoute? 'pt-2': ''}'><div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal">
        <i class="ti ti-route mt-1.5 text-2xl"></i>
        <div class="w-3.5 h-3.5 rounded mb-1" style='background: ${routePrimaryColor}'></div>
        ${isLocked ? `<i class="ti ti-lock text-red-600 text-2xl"></i>` : ''}
        <span class='font-bold'>${routeName}</span>
      </div>
        <div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal">
          <i class="ti ti-map-pin text-2xl"></i>
        <span><span class="font-semibold">${this._utilityService.getLocaleValue('text.end_location')}</span>: ${endLocation}</span>
        </div>
        <div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal">
          <i class="ti ti-clock text-2xl"></i>
        <span><span class="font-semibold">${this._utilityService.getLocaleValue('text.end_time')}</span>: ${routeEndDateTime}</span>
        </div>
        </div>
    </div>`;
    return templateHTML;
  }

  getRouteHomePopupContent(routeDetails: any, selectedJobCount: number = 0,  timezone: any = this._utilityService.timeZone): string {
    const routeName = routeDetails?.route_name || '';
    const routePrimaryColor = routeDetails?.color || '#D21C1C';
    const startLocation = this.getCityAddress(routeDetails?.start_location);
    const isLocked = routeDetails?.is_locked;
    const duration = routeDetails?.duration || 0;
    const maxAssigedToprofile = 4;
    const isRecurringRoute: boolean = routeDetails?.is_recurrence;
    const routeJobCount: any = routeDetails?.jobs?.length || '0';
    let rrText: string = null;
    if (isRecurringRoute) {
      const rrule: string = routeDetails?.recurring_route?.rrule;
      try {
        rrText = RRule?.fromString(rrule).toText();
      }
      catch {
        rrText = null;
      }
    }
    const routeStartDateTime = moment(routeDetails?.departure).tz(timezone).format(this._utilityService.dateTimeFormat);
    const templateHTML = `<div class="flex flex-col p-2 pt-0 space-y-2">
      <div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal space-y-2">
        <i class="ti ti-route mt-1.5 text-2xl"></i>
        <div class="w-3.5 h-3.5 rounded mb-1" style='background: ${routePrimaryColor}'></div>
        ${isLocked ? `<i class="ti ti-lock text-red-600 text-2xl"></i>` : ''}
        <span class='font-semibold' id="route-title">${routeName}</span>
      </div>
        ${isRecurringRoute && rrText? `<div class='flex items-center space-x-2'>
        <div class="min-w-fit">
          <i class="ti ti-repeat text-2xl text-light-blue"></i>
        </div>
        <div class="flex items-center space-x-1 text-base primary-font font-medium text-gray-700">
            <span>${this._utilityService.getLocaleValue('text.repeats', 'Repeats')}
            <span class="font-semibold">${rrText}</span>
            </span>
        </div>
          </div>`: ''}
        ${routeJobCount? `<div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal">
          <i class="ti ti-briefcase text-2xl"></i>
        <span><span class="font-semibold">${this._utilityService.getLocaleValue('text.jobs')}</span>: ${routeJobCount}</span>
        </div>`: ''}
        <div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal">
          <i class="ti ti-map-pin text-2xl"></i>
        <span><span class="font-semibold">${this._utilityService.getLocaleValue('text.start_location')}</span>: ${startLocation}</span>
        </div>
        <div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal">
          <i class="ti ti-clock text-2xl"></i>
        <span><span class="font-semibold">${this._utilityService.getLocaleValue('text.start_time')}</span>: ${routeStartDateTime} (${duration} ${duration > 1 ? 'hrs': 'hr'})</span>
        </div>
          ${this.getAssignedToAvatarView(routeDetails?.assigned_to || [], maxAssigedToprofile)}
          ${selectedJobCount ? `<div class="flex justify-center text-center primary-font text-base text-gray-700">
        <button type="button" id="add-job-to-route-btn" class="px-4 items-center py-1.5 border border-gray-300 shadow-sm rounded-md text-gray-700 font-normal bg-white hover:bg-gray-50 focus:outline-none"> Add ${selectedJobCount} Job(s) to Route </button>
      </div>`: ''}
    </div>`;
    return templateHTML;
  }

  getRouteDestinationPopupContent(routeDetails: any,  timezone: any = this._utilityService.timeZone): string {
    const routeName = routeDetails?.route_name || '';
    const routePrimaryColor = routeDetails?.color || '#D21C1C';
    const endLocation = this.getCityAddress(routeDetails?.end_location);
    const isLocked = routeDetails?.is_locked;
    const duration = routeDetails?.duration || 0;
    const routeEndDateTime = moment(routeDetails?.departure).add(duration, 'hours').tz(timezone).format(this._utilityService.dateTimeFormat);
    const templateHTML = `<div class="flex flex-col p-2 pt-0 space-y-2">
      <div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal space-y-2">
        <i class="ti ti-route mt-1.5 text-2xl"></i>
        <div class="w-3.5 h-3.5 rounded mb-1" style='background: ${routePrimaryColor}'></div>
        ${isLocked ? `<i class="ti ti-lock text-red-600 text-2xl"></i>` : ''}
        <span class='font-semibold'>${routeName}</span>
      </div>
        <div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal">
          <i class="ti ti-map-pin text-2xl"></i>
        <span><span class="font-semibold">${this._utilityService.getLocaleValue('text.end_location')}</span>: ${endLocation}</span>
        </div>
        <div class="flex items-center space-x-2 primary-font text-base text-gray-700 font-normal">
          <i class="ti ti-clock text-2xl"></i>
        <span><span class="font-semibold">${this._utilityService.getLocaleValue('text.end_time')}</span>: ${routeEndDateTime}</span>
        </div>
    </div>`;
    return templateHTML;
  }

  getRecurringRouteCardRenderer(rrRouteDetails: any): string {
    const routeName = rrRouteDetails?.recurring_route_name || '';
    const assignedTo = rrRouteDetails?.assigned_to || [];
    const totalInstances = rrRouteDetails?.total_routes || 0;
    const routeColor = rrRouteDetails?.color || '#60a5fa';
    const distanceUnit: string = this._utilityService.companyConfig?.general?.distance_metric === 'MILES' ? 'Mi' : 'Km';
    const totalDistance = this._utilityService.getDistance(rrRouteDetails?.total_distance || 0) || 0;
    const totalHour = this._utilityService.getHours(rrRouteDetails?.total_time || 0);
    const totalJobs = rrRouteDetails?.recurring_jobs?.length || 0;
    let totalMin = this._utilityService.getMin(rrRouteDetails?.total_time || 0);
    if (!totalHour && !totalMin) {
      totalMin = '0';
    }
    const maxAssigedToprofile = 4;
    let templateHTML: string = '';
    templateHTML += `<div class="w-full h-full min-w-72 font-normal text-base text-gray-700 bg-white border border-gray-200 cursor-pointer rounded-lg dark:bg-gray-800 dark:border-gray-700">
    <div class="w-full h-auto">
      <!-- Content -->
      <div class="w-full p-2"> 
      <div class="w-full flex items-center gap-2">
        <div class='min-w-fit'><div class="w-3.5 h-3.5 mb-1 rounded-sm" style="background-color: ${routeColor};"></div></div>
        <div class="primary-font text-base font-semibold text-gray-700 block truncate flex-1" title="${routeName}">${routeName}</div>
        <!-- <i class="ti ti-dots-vertical p-1 rounded-lg hover:bg-gray-100"></i> -->
      </div>
      <div class="w-full flex items-center justify-between gap-2 text-gray-400 font-normal text-base pt-1.5">
        <span>${this._utilityService.getLocaleValue('timesheet.approval.distance', 'Distance')}</span>
        <span class="truncate" title='${this._utilityService.getLocaleValue('text.total_distance', 'Total Distance')} & ${this._utilityService.getLocaleValue('label.total_time', 'Total Time')}'>${totalDistance} ${distanceUnit} (${totalHour ? totalHour + ' ' : ''}${totalHour ? this._utilityService.getLocaleValue('route.hours') + ' ' : ''}${totalMin ? totalMin + ' ' : ''}${totalMin ? this._utilityService.getLocaleValue('route.min') : ''})</span>
      </div>
      <div class="w-full flex items-center justify-between gap-2 text-gray-400 font-normal text-base pt-1.5">
      <span>${this._utilityService.getLocaleValue('text.recurring_jobs', 'Recurring Jobs')}</span>
      <span class="truncate">${totalJobs || 0}</span>
      </div>
      </div>
      <!-- External Footer -->`;
    templateHTML += `<div class="p-2 rounded-b-lg bg-gray-100 mb-2 primary-font ${assignedTo?.length ? 'py-1.5' : ''}">
      <div class="flex justify-between items-center">
        <div class="flex items-center">`;
    if (assignedTo?.length) {
      templateHTML += `<div class='flex items-center assigned-to' id="assign-user-btn">`;
      assignedTo?.slice(0, maxAssigedToprofile).forEach((assignee: any, index: number) => {
        const profilePicture = assignee?.user?.profile_picture;
        const userName = this._utilityService.concatTwoStrings(assignee?.user?.first_name, assignee?.user?.last_name) || assignee?.team?.team_name || '';
        if (profilePicture && userName && this._utilityService.hasValidProfilePicture(profilePicture)) {
          templateHTML += `<img class="h-6 w-6 relative rounded-full ring-2 ring-white" loading="lazy" src="${profilePicture}" alt="${userName}" title="${userName}" style="left: -${index * 5}px; z-index: ${maxAssigedToprofile - index};">`;
        }
        if (userName && !this._utilityService.hasValidProfilePicture(profilePicture)) {
          templateHTML += `<div title="${userName}" class="flex relative items-center justify-center h-6 w-6 rounded-full overflow-hidden" style="left: -${index * 5}px; z-index: ${maxAssigedToprofile - index};">
              <div class="flex items-center justify-center h-6 w-6 ring-2 ring-white rounded-full uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200 ng-star-inserted"> ${userName.slice(0, 1)}</div>
            </div>`;
        }
      });
      if (assignedTo?.length > maxAssigedToprofile) {
        templateHTML += `<span class='primary-font relative text-base -left-5 text-gray-700 ml-2'> + ${assignedTo?.length - maxAssigedToprofile} ${this._utilityService.getLocaleValue('text.more', 'More')}</span>`;
      }
      templateHTML += `</div>`;
      templateHTML += `</div>`;
    }
    else {
      templateHTML += `<div class='flex items-center gap-1 font-medium text-base primary-font' id="assign-user-btn" style="color: #0277BD;"><i class='ti ti-user-plus text-2xl'></i><span>${this._utilityService.getLocaleValue('assign.employee.title')}</span></div>`;
      templateHTML += `</div>`;
    }
    templateHTML += `<span class='text-base text-gray-500 primary-font font-normal'>${totalInstances} ${totalInstances <= 1 ? this._utilityService.getLocaleValue('text.instance', 'Instance') : this._utilityService.getLocaleValue('text.instances', 'Instances')}</span>
      </div>
    </div>
    </div>`;
    return templateHTML;
  }

  routeGridCardValueRenderer(routeDetails: any, selector: any): any[] {
    let templateHTML: string = '';
    const routeCreatedAt = this._dispatchBoardService.formatDateTime(routeDetails?.created_at);
    const routeStartDateTime = moment(routeDetails?.departure);
    const routeDuration = routeDetails?.duration || 1;
    const routeEndDateTime = routeStartDateTime.clone().add(routeDuration, 'h');
    const routeStartEndTime = this._dispatchBoardService.getStartEndTime(routeStartDateTime, routeEndDateTime, false);
    const startLocation = this.getCityAddress(routeDetails?.start_location);
    const endLocation = this.getCityAddress(routeDetails?.end_location);
    const modeOfTransport = this.titlecasePipe.transform(routeDetails.transport_mode || 'CAR');
    let hasValue: boolean = false;
    switch (selector) {
      case 'created_at': {
        templateHTML += `<div class="flex items-center"><i class="ti ti-calendar-plus text-gray-700 text-2xl mr-1.5"></i><span class="block truncate primary-font text-base font-normal" title="Created at: ${routeCreatedAt}">${routeCreatedAt}</span></div>`;
        hasValue = true;
        break;
      }
      case 'departure': {
        templateHTML += `<div class="flex items-center"><i class="ti ti-calendar-due text-gray-700 text-2xl mr-1.5"></i><span class="block truncate primary-font text-base font-normal" title="Route departure: ${routeStartEndTime[0]}">${routeStartEndTime[0]}</span></div>`;
        hasValue = true;
        break;
      }
      case 'start_location': {
        if (startLocation) {
          templateHTML += `<div class="flex items-center"><i class="ti ti-home text-gray-700 text-2xl mr-1.5"></i><span class="block truncate primary-font text-base font-normal" title="Start location: ${startLocation}">${startLocation}</span></div>`;
          hasValue = true;
        }
        break;
      }
      case 'end_location': {
        if (endLocation) {
          templateHTML += `<div class="flex items-center"><i class="ti ti-flag text-gray-700 text-2xl mr-1.5"></i><span class="block truncate primary-font text-base font-normal"  title="End location: ${endLocation}">${endLocation}</span></div>`;
          hasValue = true;
        }
        break;
      }
      case 'transport_mode': {
        templateHTML += `<div class="flex items-center"> <i class="${modeOfTransport === 'Car' ? 'ti ti-car' : modeOfTransport === 'Truck' ? 'ti ti-truck' : 'ti ti-walk'} text-gray-700 text-2xl mr-1.5"></i><span class="block truncate primary-font text-base font-normal" title="Transport mode: ${modeOfTransport}">${modeOfTransport}</span></div>`;
        hasValue = true;
        break;
      }
    }
    return [templateHTML, hasValue];
  }

  sanitizeGridRoutecardSelector(selectors: any[]): any[] {
    selectors = _.uniq(selectors);
    const locationSelectors = ['start_location', 'end_location'];
    const isEveryLocationSelectorIncluded = locationSelectors.every((locationSelector: any) => selectors.includes(locationSelector));
    if (isEveryLocationSelectorIncluded) {
      selectors = selectors.filter((selector: any) => !locationSelectors.includes(selector));
      selectors.push('start_end_location');
    }
    return selectors;
  }

  getCityAddress(address: any): string {
    const addressArray: string[] = [];
    if (address?.street) {
      addressArray.push(address.street);
    }
    if (address?.name) {
      addressArray.push(address.name);
    }
    if (address?.landmark) {
      addressArray.push(address.landmark);
    }
    if (address?.city) {
      addressArray.push(address.city);
    }
    if (address?.state) {
      addressArray.push(address.state);
    }
    if (address?.zip_code) {
      addressArray.push(address.zip_code);
    }
    return addressArray.length > 0 ? addressArray.join(', ') : '';
  }

  updateTimeSheetValue(): void {
    if (this.viewMode === 'DAY' && this.userDetails?.timesheet?.length) {
      const timesheet: any[] = this.userDetails?.timesheet;
      const punchedOutIndex: number = timesheet?.lastIndexOf((value: any) => value.type_of_check === 'CHECK_OUT');
      this.timeSheetValue = {
        punchedIn: timesheet?.find((value: any) => value.type_of_check === 'CHECK_IN')?.checked_time ?? null,
        punchedOut: punchedOutIndex > -1 ? (timesheet?.[punchedOutIndex]?.checked_time || null) : null
      };
    }
  }

  updateCapacityHours(workMins: number, availableMins: number): void {
    if (this.viewMode === 'DAY' && workMins) {
      let capacity: number = 0;
      if (workMins) {
        capacity = Math.trunc((workMins - availableMins) > 0 ? (workMins - availableMins) : (workMins || 0));
      }
      this.capacityHours = this._utilityService.getTimeLogValue(availableMins);
    }
  }

  //Date time should be in IST (YYYY-MM-DD)
  getUserCapacity(userUid: string, fromDate: string, toDate: string): Promise<number[]> {
    const fromDateTime = fromDate + ' 00:00:00';
    const toDateTime = toDate + ' 23:59:59';
    const userAvailabilityPayload = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      from_date_time: fromDateTime, to_date_time: toDateTime, user_uid: userUid
    };
    return new Promise((resolve, reject) => {
      this._dataCollectorService.getData(this._dispatchBoardService.userAvailabilityUrl, userAvailabilityPayload)
        .subscribe((response) => {
          const data = response?.data || [];
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const userCapacity = _.find(data, { 'user_uid': userUid });
          if (userCapacity) {
            const availableMins = userCapacity?.work_mins.available_mins || 0;
            const workMins = userCapacity?.work_mins.work_mins || 0;
            resolve([workMins, availableMins]);
          }
          else {
            resolve([0, 0]);
          }
        }, (error) => {
          resolve([0, 0]);
        });
    });
  }

  getCapacityPercentage(workMins: number, availableMins: number): number {
    if (this.viewMode === 'DAY' && availableMins && workMins) {
      return 100 - Math.trunc((availableMins / workMins) * 100);
    }
    return 0;
  }

  getWorkHours(): string {
    if (this.dateRange.fromDate) {
      const workingDay: string = dayjs(this.dateRange.fromDate).format('dddd');
      const userWorkingDay: any = this.userDetails.work_hours?.find((day: any) => day.day === workingDay);
      if (userWorkingDay?.start_time && userWorkingDay?.end_time) {
        return this.timePipe.transform(userWorkingDay?.start_time, false, 'HH:mm:ss', this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]) + ' - ' + this.timePipe.transform(userWorkingDay?.end_time, false, 'HH:mm:ss', this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]);
      }
    }
    return '';
  }

  isExpired(date: string): boolean {
    return dayjs(date).isBefore(dayjs());
  }

  previewClose(): void {
    this.previewEmitter.emit({ isPreviewClosed: true });
  }
}

